import { useState, useEffect, useContext, useRef } from "react";
import {
  APIs,
  API_BASE_URL,
  REPORT_TITLE,
  TOAST_TYPE,
  REPORTDONESTATUS,
  VDCLIMS,
  MODAL_TYPE,
  REPORT_SUBMIT_SOURCE,
  SHARED_SERVICEURL,
  DICOM_ACCEPTOR_BASE_URL,
  NonAuthRoutes,
  TAB_NAME,
} from "../../constants/Constants";
import { StringLiterals } from "../../constants/StringLiterals";
import { useTranslation } from "react-i18next";
import { USERTYPES } from "../../constants/Constants";
import { useParams, useSearchParams } from "react-router-dom";
import Moment from "moment";
import {
  assignStudy,
  downloadAIReportAPI,
  downloadFistolugramImage,
  downloadPdfReport,
  generateCTBrainReportCall,
  generateMRISpineReportCall,
  generateRSNADynamicReport,
  getPatientReportData,
  getQCProvidersList,
  getReportTemplatesData,
  getS10ReportData,
  getStorageKeyFistolugram,
  getStudyReportData,
  getWordSession,
  markAsSuspect,
  previewPdfReport,
  previewPdfReportVersion,
  regenerateLLMReport,
  saveReportTemplatesData,
  submitQC,
  submitReportTemplatesData,
  uploadFistolugramService,
} from "../../service/StudyReportService";
import StudyReportContext from "../studyreport/StudyReportContext";
import userContext from "../users/UserContext";
import ViewportContext from "../studyviewer/ViewportContext";
import studyviewerContext from "../studyviewer/StudyviewerContext";
import { generateRSNAReport } from "../../pages/Report/helper/RSNAUtilities";
import {
  annotation_state,
  init_pathology_state,
} from "../../pages/Annotations/helper/initialData";
import { ReleaseStudyApi, ReturnStudyApi } from "../../service/StudyViewerService";
import { savingBoundingBoxJsonData } from "../../pages/StudyViewer/helpers/BoundingBoxUtilities";
import { getViewport } from "../../pages/StudyViewer/helpers/CornerstoneViewportService";
import loaderContext from "../loader/LoaderContext";
import toastContext from "../toast/ToastContext";
import { isMobile } from "react-device-detect";
import { logAmplitudeEventWithUsernameAndRole } from "../../helpers/Amplitude";
import { keyImagesPresent } from "../../pages/StudyViewer/helpers/KeyImageUtility";
import { assignMeSupervisor } from "../../service/StudyListService";
import themeContext from "../theme/ThemeContext";
import OrientationDetector from "../../components/OrientationDetector";
import ModalHeader from "../../components/Modal/ModalHeader";
import ModalFooter from "../../components/Modal/ModalFooter";
import studylistContext from "../studylist/StudylistContext";
import { generateRandomString } from "../../helpers/CommonUtility";
import { loadAndCacheImage } from "@cornerstonejs/core/loaders/imageLoader";
import { loadDicomAndDrawRectangle, removeMaskImageAnnotation } from "../../service/MaskImageService";

const StudyReportState = (props) => {
  const {
    roles,
    username,
    userId,
    qcReviewer,
    enableLlmReport,
    privilegedFirmDoctor,
    disableSubmitforResident
  } = useContext(userContext);

  const { themeName } = useContext(themeContext);


  // Get studyClinicalNotesData from studyviewerContext if available
  let studyClinicalNotesData = null;
  const studyViewerData = useContext(studyviewerContext);
  const maskImages = studyViewerData?.maskImages ?? {};
  const setMaskImages = studyViewerData?.setMaskImages ?? (() => { });
  const viewerContextData = useContext(ViewportContext);
  const disableMasking = viewerContextData?.disableMasking ?? (()=>{});
  try {

    if (studyViewerData && studyViewerData.studyClinicalNotesData) {
      studyClinicalNotesData = studyViewerData.studyClinicalNotesData;
    }

  } catch (error) {
    console.log("Error accessing studyviewerContext:", error);
  }
  //const {
  // assignmentData,
  // keyImages,
  // studyParentId,
  //setAlertSuccessModal,
  //alertSuccessModal,
  //confirmAlertModal, setConfirmAlertModal,
  //qcData,
  //showToast, setShowToast,
  //} = useContext(studyviewerContext);

  const { ref, setLoaderRunning, setShowModal, showModal } =
    useContext(loaderContext);
  const { showToastv2 } = useContext(toastContext);


  // const {
  //annotationData,
  //setDisableAddPathology,
  //activeViewportIndex } =
  //useContext(ViewportContext);

  const [studyId, setStudyId] = useState(null);
  const [t] = useTranslation();
  // const [patientId, setPatientId] = useState(440);
  const { patientID } = useParams();
  const [studyData, setStudyData] = useState();
  const [model, setModel] = useState("");

  const [addendumModel, setAddendumModel] = useState("");
  const [patientReports, setPatientReports] = useState([]);
  const [oldPatientReports, setOldPatientReports] = useState([]);

  const [childModel, setChildModel] = useState("");
  const [childPatientReports, setChildPatientReports] = useState([]);
  const [childCurrentActiveTab, setChildCurrentActiveTab] = useState("");
  // const [showToast, setShowToast] = useState({
  //   show: false,
  //   message: "",
  //   loading: false,
  //   state: "success",
  // });
  const [currentActiveTab, setCurrentActiveTab] = useState("");
  const [userRole, setUserRole] = useState(null);
  const [modality, setModality] = useState("");
  const [studyDescription, setStudyDescription] = useState("");
  const [showAlert, setShowAlert] = useState(true);
  const [hideDialog, setToggleHideDialog] = useState(true);
  const [stopEffect, setStopEffect] = useState(false);
  const [isDraggable, setToggleIsDraggable] = useState(false);
  const [enableReportRegenerate, setEnableReportRegenerate] = useState(false);
  const [selectedCategoryTemplate, setSelectedCategoryTemplate] = useState(
    "deeptekReportTemplage"
  );
  const [suggestedListReport, setSuggestedListReport] = useState([]);
  const [firstReportAdded, setFirstReportAdded] = useState(false);
  const [allReportTemplates, setAllReportTemplates] = useState({});
  const [agenticReportAgents, setAgenticReportAgents] = useState([]);
  const [allReportTemplatesLoading, setAllReportTemplateLoading] = useState(false);
  const [raiseAlertList, setRaiseAlertList] = useState([]);
  const [raiseAlertValue, setRaiseAlertValue] = useState();
  const [dropdownSelectedTemplates, setDropdownSelectedTemplates] = useState(
    []
  );
  const [dropdownSelectedTemplatesStore, setDropdownSelectedTemplatesStore] =
    useState([]);
  const [annotationsJson, setAnnotationsJson] = useState("");
  const [studyOptionJson, setStudyOptionJson] = useState("");
  const [reset, setReset] = useState(false);
  const [userActionLoading, setUserActionLoading] = useState(true);

  const [disablePreview, setDisablePreview] = useState(true);
  const [disableQCPass, setDisableQCPass] = useState(true);
  const [disableQCReturn, setDisableQCReturn] = useState(true);
  const [disableQCReason, setDisableQcReason] = useState(true);
  const [disableSave, setDisableSave] = useState(true);

  const [disableSubmit, setDisableSubmit] = useState(true);
  // flog to show word
  const [showMsWord, setShowMsWord] = useState(false);
  const [isWordFilePath, setIsWordFilePath] = useState(false);
  const [showQCReasonBadge, setShowQCReasonBadge] = useState(false);
  const [disableSubmitUntilQCReasonClick, setDisableSubmitUntilQCReasonClick] =
    useState(false);
  const [disableDownload, setDisableDownload] = useState(true);
  const [disableRaiseAlert, setDisableRaiseAlert] = useState(true);
  const [disablePenEye, setDisablePenEye] = useState(true);
  const [showLockWarning, setShowLockWarning] = useState(false);
  const [hideLockWarningMessage, setHideLockWarningMessage] = useState(false);
  const [alreadyLocked, setAlreadyLocked] = useState(false);
  const [lockedByOther, setLockedByOther] = useState(false)
  const [showLockButton, setShowLockButton] = useState(true);
  const [openRSNAModal, setOpenRSNAModal] = useState(false);
  const [RSNAModalContent, setRSNAModalContent] = useState();
  const [reportModalState, setReportModalState] = useState({
    hrctChestILD: false,
    hrctChestCovid: false,
    ctBrain: false,
    mriSpine: false,
    content: {},
    id: null,
  });
  const [reportMenu, setReportMenu] = useState(false);
  const [seriesMenu, setSeriesMenu] = useState(false);
  const [reportingDoctorName, setReportingDoctorName] = useState(null);
  const [isExternal, setIsExternal] = useState(false);
  const [allStoreAnnotations, setAllStoreAnnotation] = useState([]);
  const [reportAnnotationState, setReportAnnotationState] =
    useState(annotation_state);
  const [addStoreAnnotationState, setAddStoreAnnotationState] = useState(
    JSON.parse(JSON.stringify(init_pathology_state))
  );
  const [openQCPassConfirmModal, setOpenQCPassConfirmModal] = useState(false);
  const [isKeyImagesPresent, setIsKeyImagesPresent] = useState(false);
  const [isTextAnnotationPresent, setIsTextAnnotationPresent] = useState(false);
  const [openQcModal, setOpenQcModal] = useState(false);
  const [openQcReasonModal, setOpenQcReasonModal] = useState(false);
  const [openFistolugramUploadModal, setFistolugramUploadModal] =
    useState(false);
  const [qcFailReason, setQcFailReason] = useState("");
  const [qcProviderList, setQcProviderList] = useState([]);
  const [qcFixerId, setQCFixerId] = useState("");
  const [showKeyImagesAndTextAnnotation, setShowKeyImagesAndTextAnnotation] =
    useState(false);
  const [showReturnedStudyReasonModal, setShowReturnedStudyReasonModal] =
    useState(false);
  const [cancelClicked, setCancelClicked] = useState(true);
  // TODO
  const [activeTab, setActiveTab] = useState(1);
  const [disableAddendumTab, setDisableAddendumTab] = useState(true);
  const [showReturnStudyModal, setShowReturnStudyModal] = useState(false);
  const [reportDoneStatusState, setReportDoneStatusState] = useState(null);
  const [showCommunicationModal, setShowCommunicationModal] = useState(false);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [updateRowSubmitDone, setUpdateDoneSubmitDone] = useState({
    id: null,
    show: false,
  });
  const [studyPatientDetails, setStudyPatientDetails] = useState({
    patientName: null,
    patientId: null,
  });
  //  str.substring(str.lastIndexOf('/') + 1);
  const [searchParams] = useSearchParams();
  const [studyParentId, setStudyParentId] = useState(
    window.location.pathname.includes("studylist")
      ? null
      : window.location.pathname.includes(NonAuthRoutes.CONTEXTSWITCHSTUDYVIEWER) ? searchParams.get("studyId") : window.location.pathname.substring(
        window.location.pathname.lastIndexOf("/") + 1
      )
  );
  const [firmId, setFirmId] = useState(searchParams.get("firmId"));
  const isStudyList = true;



  const [openReportModal, setOpenReportModal] = useState(false);
  const [keyImagePresentStudyList, setKeyImagePresentStudyList] =
    useState(false);
  const [modalityReport, setModalityReport] = useState("");
  const [isClientReportExist, setIsClientReportExist] = useState(false);
  const [
    isClientReportExistExternalModal,
    setIsClientReportExistExternalModal,
  ] = useState(null);
  const [isDSRExists, setIsDSRExists] = useState(false);
  const [showFistolugram, setShowFistolugram] = useState(false);
  const [fistolugramFilePath, setFistolugramFilePath] = useState(null);
  const [conflictSave, setConflictSave] = useState("0");
  const [passConflict, setPassConflict] = useState(null);
  const [addendumDisclaimerEnabled, setAddendumDisclaimerEnabled] =
    useState(false);
  const [addendumDisclaimerAddedByRad, setAddendumDisclaimerAddedByRad] =
    useState(false);
  const [showAddendumDisclaimerModal, setShowAddendumDisclaimerModal] =
    useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showAddendumDisclaimerPopup, setShowAddendumDisclaimerPopup] =
    useState(true);
  const [showSubmitTick, setShowSubmitTick] = useState(false);
  const [showSuspectIcon, setShowSuspectIcon] = useState(false);
  const [disableMarkAsSuspect, setDisableMarkAsSuspect] = useState(true);
  const [reportSavedSuccess, setReportSaveSuccess] = useState(null);
  const [allowDownloadReport, setAllowDownloadReport] = useState(true);
  const [isAdvanceViewer, setIsAdvanceViewer] = useState(false);
  const [alertSuccessModal, setAlertSuccessModal] = useState({
    show: false,
    isError: false,
    isWarning: false,
    isSuccess: false,
    heading: "",
    description: "",
  });
  const [confirmAlertModal, setConfirmAlertModal] = useState({
    isConflictPopup: false,
    show: false,
    isError: false,
    isWarning: false,
    isSuccess: false,
    confirmClicked: false,
    heading: "",
    description: "",
    type: "save",
    qcData: {},
    allTextToolData: "",
    checkKeyImagesAndTextAnnotation: false
  });
  const externalReportingModalRef = useRef(null);
  const [externalReportingLoading, setExternalReportingLoading] =
    useState(true);
  const [isChildStudyReportState, setIsChildStudyReportState] = useState(false);
  const [allowCopyPaste, setAllowCopyPaste] = useState(false);
  const [isRestrictionsEnabled, setIsRestrictionsEnabled] = useState(false);
  const [forceReinferenceInProgress, setForReinferenceInProgress] = useState(false);
  const [showForceReinferenceModal, setShowForceReinferenceModal] = useState(false);
  const [observationState, setObservationState] = useState({
    clinicalHistory: "",
    comparison: "",
    technique: "",
    findings: "",
    impressions: ""
  })
  const [activeField, setActiveField] = useState(null);
  const [findingSentence, setFindingSentence] = useState("");
  const [disableObservations, setDisableObservations] = useState(false);
  const [llmReportTitle, setLlmReportTitle] = useState("");
  const [reportSavedBy, setReportSavedBy] = useState(0);
  const [showFindingsErrorMessage, setShowFindingsErrorMessage] = useState(false);

  const [showTemplateList, setShowTemplateList] = useState({
    showTemplate: true,
    selectedList: "deeptekReportTemplage"
  });
  const [rsnaFlag, setRSNAFlag] = useState(false);
  const [autoOpenReportPanel, setAutoOpenReportPanel] = useState(false);
  const [s10User, setS10User] = useState(false);
  const [s10Url, setS10Url] = useState(null);
  const [isLandscape, setIsLandscape] = useState(OrientationDetector());
  const [confirmMultipleTemplateOpen, setConfirmMultipleTemplateOpen] = useState(false);
  const [confirmMultipleTemplateModalContent, setConfirmMultipleTemplateModalContent] = useState(null);
  const editorRef = useRef(null);
  const [inputValue, setInputValue] = useState('');
  const [formatterAgentEnabled, setFormatterAgentEnabled] = useState(false);
  const [showFormatterPopup, setShowFormatterPopup] = useState(false);
  const [showFormatterPopupClipped, setShowFormatterPopupClipped] = useState(false);
  const [clippedKeyImagesData, setClippedKeyImagesData] = useState([]);
  const [previewClippedKeyImageBase64, setPreviewClippedKeyImageBase64] = useState("");

  const [formattedReportAction, setFormattedReportAction] = useState("");
  const [pendingSubmission, setPendingSubmission] = useState(null);
  const [submissionParams, setSubmissionParams] = useState(null);
  const [pendingQCPass, setPendingQCPass] = useState(null);
  const [qcPassParams, setQCPassParams] = useState(null);
  const [formattedReportUsed, setFormattedReportUsed] = useState(false);
  const [usgAgentEnabled, setUsgAgentEnabled] = useState(0);
  const [maskedImageEnabledLimit, setMaskedImageEnabledLimit] = useState(0);
  const [templateHeight, setTemplateHeight] = useState(0);
  const [reviewerId, setReviewerId] = useState(null);
  const [reviewStatus, setReviewStatus] = useState(null);
  const [firstAgenticLLMReport, setFirstAgenticLLMReport] = useState("");
  const [userPrompts, setUserPrompts] = useState([]);
  const [disableResetReport, setDisableResetReport] = useState(true);
  const [disableCopyButton, setDisableCopyButton] = useState(true);
  const [reportFromAPI, setReportFromAPI] = useState("");
  const [reportTitle, setReportTitle] = useState("");
  const [llmSessionId, setLlmSessionId] = useState("");
  const [resetLLMReportClicked, setResetLLMReportClicked] = useState(false);
  const chatInputRef = useRef(null);
  //register function for MicToolComponent

  let isBvpPlatform = (process.env.REACT_APP_BVP_PLATFORM == "true" || process.env.REACT_APP_BVP_PLATFORM == true) ? true : false;

  const registerChatInputRef = (ref) => {
    chatInputRef.current = ref.current;
  };

  const handleUpdateStudyId = (id) => {
    // console.log("Study Id ", id);
  };

  useEffect(()=>{
    console.log("report modal 2", openReportModal);
    setModel("");
  }, [openReportModal]);

  useEffect(() => {
    if (
      firmId != null &&
      firmId != undefined &&
      studyParentId != null &&
      isExternal &&
      isClientReportExistExternalModal != null && !isMobile
    ) {
      // console.log("---- Loading External Reporting ----");
      setExternalReportingLoading(true);
      setLoaderRunning(true);
      ref.current.continuousStart();

      setTimeout(() => {
        setDisablePreview(true);
        setDisableQCPass(true);
        setDisableQCReturn(true);
        setDisableQcReason(true);
        setDisableSave(true);
        setDisableSubmit(true);
        setShowQCReasonBadge(false);
        setDisableSubmitUntilQCReasonClick(false);
        setDisableDownload(true);
        setDisableRaiseAlert(true);
        setShowLockWarning(false);
        setHideLockWarningMessage(false);
        setAlreadyLocked(false);
        setLockedByOther(false);
        setReportDoneStatusState(null);
        setOpenReportModal(true);
        setReportingDoctorName(null);
        setShowMsWord(false);
        setIsWordFilePath(false);
        setAllowCopyPaste(false);
        setRaiseAlertValue();
        setRaiseAlertList([]);
      }, 100);

      setTimeout(() => {
        let res = getData(false);
        if (res) {
          setExternalReportingLoading(false);
        }
      }, 200);
    }
  }, [
    studyParentId,
    firmId,
    isExternal,
    isClientReportExistExternalModal,
    keyImagePresentStudyList,
  ]);

  const getData = async (refresh, isReportSubmitted = true) => {
    //  console.log("--- Running Get Data ----");
    if (refresh) {
      setLlmReportTitle("");
      setShowFindingsErrorMessage(false);
    }
    if (firmId == null) {
      return;
    }
    if (!isExternal && studyId == null) {
      getAllReport(studyParentId);
    }
    setSelectedCategoryTemplate("deeptekReportTemplage");
    try {
      const response = await getStudyReportData(studyParentId, firmId);
      if (response.status === 200) {
        let data = response.data.data.studyReportList;
        setModality(response.data.data.modality);
        setStudyDescription(response.data.data.studyDescription)
        setQcFailReason(response.data.data.qcfailReason);
        setAddendumDisclaimerEnabled(
          response.data.data.addendumDisclaimerEnabled
        );
        setAllowDownloadReport(response.data.data.allowDownloadReport);
        setS10User(response?.data?.data?.s10User);
        setS10Url(response?.data?.data?.s10Url);
        setFormatterAgentEnabled(response?.data?.data?.formatterAgentEnabled);
        setFormattedReportUsed(response?.data?.data?.formattedReportUsed);
        setUsgAgentEnabled(response?.data?.data?.usgAgentEnabled)
        setMaskedImageEnabledLimit(response?.data?.data?.maskedImageEnabledLimit)
        let opt = [];
        let autoTemplateInd = [];
        let allowRestrictionForClientTemplate = response.data?.data?.allowRestrictionForClientTemplate;
        let allowCopyPasteForClientTemplate = response.data?.data?.allowCopyPaste;
        setLlmReportTitle(response.data?.data?.llmreportTitle)
        setLlmSessionId(generateRandomString(userId, response.data.data.id));
        data.map((ele) => {
          // console.log("IS CLIENT REPORT EXIST ", isClientReportExist);
          if (allowRestrictionForClientTemplate != null && allowRestrictionForClientTemplate == true &&
            isClientReportExist != null &&
            isClientReportExist == true &&
            allowCopyPasteForClientTemplate != null && allowCopyPasteForClientTemplate == false &&
            (ele.isSuperSpecialReport == 1 ||
              ele.reportTemplateTitle.includes("BLANK"))
          ) {
            return null;
          }

          if (ele.isSuperSpecialReport) {
            let updatedFontSizeReport = convertFontSize(ele.finalReport);
            ele.finalReport = updatedFontSizeReport;
            autoTemplateInd.push(ele);
          } else {
            opt.push({
              key: ele.id,
              text: ele.reportTemplateTitle,
              isSuperSpecialReport: ele.isSuperSpecialReport,
              reportDetails: ele,
              addendum: ele.addendum,
            });
          }
          if (ele.reportTemplateTitle.includes("LLM")) {
            setSelectedCategoryTemplate("dsrTemplate")
          }
        });
        if (autoTemplateInd != null && autoTemplateInd.length > 0) {
          autoTemplateInd.map((ele, index) => {
            opt.push({
              key: ele.id,
              text: ele.reportTemplateTitle,
              isSuperSpecialReport: ele.isSuperSpecialReport,
              reportDetails: ele,
            });
          });

          setCurrentActiveTab(
            autoTemplateInd[autoTemplateInd.length - 1].reportTemplateTitle
          );
          setModel(autoTemplateInd[autoTemplateInd.length - 1].finalReport);
        }
        // console.log("---- Added Report Template ---",opt);

        if (response.data?.data?.allowCopyPaste != null) {
          setAllowCopyPaste(response.data?.data?.allowCopyPaste);
        }
        if (response.data?.data?.allowRestrictionForClientTemplate != null) {
          setIsRestrictionsEnabled(response.data?.data?.allowRestrictionForClientTemplate);
        }
        setRaiseAlertListFunc(response.data?.data?.raiseAlertList, response.data?.data?.raiseAlert);
        setPatientReports(opt);
        setStudyId(response.data.data.id);
        setUserActionLoading(false);
        handleValidationForKeyImagesAndTextAnnotation(response.data.data);
        handleValidation(response.data.data);
        handleFistolugramVisiblity(response.data.data);
        setReportingDoctorName(response.data.data.reportingDoctor);
        setQCFixerId(response.data.data.qcfixerId);
        setReportDoneStatusState(response.data.data.reportDoneStatus);
        setReportSavedBy(response.data.data.reportSavedBy);
        setObservationState({
          clinicalHistory: response.data.data?.studyObservations?.clinicalHistory,
          comparison: response.data.data?.studyObservations?.comparison,
          technique: response.data.data?.studyObservations?.technique,
          // impressions: response.data.data?.studyObservations?.impressions,
          findings: response.data.data?.studyObservations?.findings
        })
        setFindingSentence(() => {
          const finding = response.data.data?.studyObservations?.findings.find(f => f.pathologyName.toLowerCase() == "other");
          return finding ? finding?.findingSentences[finding?.findingSentences.length - 1].sentence : "";
        })

        setAutoOpenReportPanel(!isLandscape ? false : response.data.data.autoOpenReportPanel)
        if (isReportSubmitted) {
          setSeriesMenu(response.data.data.autoOpenReportPanel ? false : isMobile ? false : refresh ? false : true);
        } else if (refresh) {
          setSeriesMenu(false);
        }
        // setReportMenu(response.data.data.autoOpenReportPanel);
        //setReportMenu(isMobile ? false : response.data.data.autoOpenReportPanel);
        //setSeriesMenu(isMobile ? false : !response.data.data.autoOpenReportPanel);
        if (!isExternal)
          setDisableMarkAsSuspect(!response.data.data.markAsSuspectedDisplay);
        // console.log("REPORT STATUS");
        // console.log(response.data.data.reportDoneStatus);
        // console.log(response.data.data.qcfixerId);
        if (
          response.data.data.reportDoneStatus === REPORTDONESTATUS.QC_FIX &&
          response.data.data.qcfixerId === userId
        ) {
          // console.log("in enable report generated button");
          //setEnableReportRegenerate(true);
        }
        if (
          (response.data.data.reportDoneStatus === REPORTDONESTATUS.QC_FIX ||
            response.data.data.reportDoneStatus ===
            REPORTDONESTATUS.QC_VERIFY) &&
          roles[0] === USERTYPES.SUPERVISOR
        ) {
          setShowQCReasonBadge(true);
        }
        setReviewerId(response.data.data.peerReviewAssignment?.reviewerId);
        setReviewStatus(response.data.data.peerReviewAssignment?.reviewStatus);
        // setShowToast((prev) => {
        //   return {
        //     ...prev,
        //     show: false,
        //     message: "",
        //     loading: false,
        //     state: "success",
        //   };
        // });
        if (
          externalReportingModalRef != null &&
          externalReportingModalRef.current != null
        ) {
          externalReportingModalRef.current.complete();
          externalReportingModalRef.current = null;
        }
        if (refresh || isExternal) {
          setLoaderRunning(false);
          ref.current.complete();
        }
        return true;
      } else {
        setUserActionLoading(false);
        if (refresh || isExternal) {
          setLoaderRunning(false);
          ref.current.complete();
        }
        setOpenReportModal(false);
        setAlertSuccessModal(() => {
          const newItem = { ...alertSuccessModal };
          newItem.show = true;
          newItem.heading = "Error";
          newItem.description = t("string-literals.failed-message");
          return newItem;
        });
      }
      setStopEffect(true);
    } catch (e) {
      setLoaderRunning(false);
      ref.current.complete();
      setOpenReportModal(false);
      setAlertSuccessModal(() => {
        const newItem = { ...alertSuccessModal };
        newItem.show = true;
        newItem.heading = "Error";
        newItem.description = t("string-literals.failed-message");
        return newItem;
      });
    }
  };

  useEffect(() => {
    if (llmReportTitle != undefined && llmReportTitle != "" && !allReportTemplatesLoading && Object.keys(allReportTemplates).length != 0 && reportDoneStatusState === 0 && reportSavedBy === 0) {
      let opt = [];
      allReportTemplates?.dsrReportTemplates?.forEach(rt => {
        if (rt.title === llmReportTitle) {
          opt.push({ key: rt.id, text: rt.title, reportDetails: rt });
          setCurrentActiveTab(rt.title);
          setModel(rt.finalReport)
        }
      })
      if (llmReportTitle.includes("Other")) {
        setDisableObservations(true);
        setActiveTab(1);
      } else {
        setDisableObservations(false)
        if (autoOpenReportPanel) {
          setActiveTab(1);
        }
      }
      setPatientReports(opt);
      setSelectedCategoryTemplate("dsrTemplate");
    }
  }, [llmReportTitle, allReportTemplatesLoading, allReportTemplates])

  const hideAlertSuccessModal = () => {
    setAlertSuccessModal(() => {
      const newItem = { ...alertSuccessModal };
      newItem.show = false;
      newItem.heading = "";
      newItem.description = "";
      return newItem;
    });

    setConfirmAlertModal(() => {
      const newItem = { ...confirmAlertModal };
      newItem.show = false;
      newItem.isConflictPopup = false;
      newItem.heading = "";
      newItem.type = "";
      newItem.description = "";
      return newItem;
    });
  };

  function convertFontSize(htmlString) {
    const fontSizeRegex = /font-size: (\d+)px;/g;
    if (fontSizeRegex.test(htmlString)) {
      const convertedHtml = htmlString.replace(
        fontSizeRegex,
        (match, fontSize) => {
          const convertedSize = Math.max(14, Math.floor((fontSize * 16) / 20));
          return `font-size: ${convertedSize}px;`;
        }
      );
      return convertedHtml;
    }
    return htmlString;
  }

  useEffect(() => {
    // if(reportingDoctorName != null)
    // console.log("----- Assignemnt is updating -------");
    // console.log(reportingDoctorName);
    handleLockWarning(reportingDoctorName);
  }, [reportingDoctorName, roles, qcFixerId, reviewerId]);

  const handleLockWarning = (reportingDoctor) => {
    console.log("----- ReportingDoctor --------", reportingDoctor, userId, reviewerId);
    setUserRole(roles[0]);
    if (roles[0] != USERTYPES.RADIOLOGIST) {
      //setDisableAddPathology(true);
      setShowLockWarning(false);
      return;
    } else {
      //setDisableAddPathology(false);
    }
    if (reportingDoctor != null && reportingDoctor != undefined) {
      if (
        roles[0] == USERTYPES.RADIOLOGIST &&
        (reportingDoctor == username || qcFixerId === userId)
      ) {
        // console.log("----- Same User Lock --------");
        setAlreadyLocked(true);
        setShowLockWarning(false);
      } else if (roles[0] == USERTYPES.RADIOLOGIST && reviewerId === userId) {
        setAlreadyLocked(false);
        setShowLockWarning(false);
      } else {
        setLockedByOther(false);
        setShowLockWarning(true);
      }
    } else {
      // console.log("----- Same Undefined User Lock --------");
      if (qcFixerId === userId) {
        setAlreadyLocked(true);
        setShowLockWarning(false);
      } else {
        // console.log("----- Same Undefined User Lock --------");
        setAlreadyLocked(false);
        setLockedByOther(true);
        setHideLockWarningMessage(false);
        setShowLockWarning(true);
      }
    }

    {
      /* To Be ADDED */
    }

    {
      /*if (
      assignmentData.assignedRadiologist != username &&
      assignmentData.assignedRadiologist != null
    ) {
      setShowLockButton(false);
    } else {
      setShowLockButton(true);
    }*/
    }
  };

  useEffect(() => {
    if (allReportTemplates != null) {
      handleSwitchCategory();
    }
  }, [selectedCategoryTemplate]);

  useEffect(() => {
    if (studyId != null && !isExternal) {
      // getRaiseAlertList(studyId);
      //getAllReport(studyId);
    }
  }, [studyId]);

  useEffect(() => {
    if (studyParentId != null && isExternal) {
      // console.log("--- Fetching All Reports ----");
      // getRaiseAlertList(studyParentId);
      getAllReport(studyParentId);
    }
  }, [studyParentId, isExternal]);

  useEffect(() => {

    if (selectedCategoryTemplate === "dsrTemplate" && patientReports.length === 0) {
      setDisableObservations(true);
      setActiveTab(1);
    } else {
      setDisableObservations(false)
    }

    if (patientReports.length > 0) {
      handleChangeTemplate(patientReports[patientReports.length - 1]);
    }
  }, [patientReports]);

  const handleSwitchCategory = (clientReportTemplate) => {
    let opt = [];
    if (allReportTemplates != null) {
      switch (selectedCategoryTemplate) {
        case "deeptekReportTemplage":
          allReportTemplates.reportTemplates?.map((ele) => {
            opt.push({ key: ele.id, text: ele.title, reportDetails: ele });
          });
          break;
        case "rsnaReportTemplage":
          allReportTemplates.rsnaReportTemplates?.map((ele) => {
            opt.push({ key: ele.id, text: ele.title, reportDetails: ele });
          });
          break;
        case "radiologistReportTemplate":
          allReportTemplates.radiologistReportTemplates?.map((ele) => {
            opt.push({ key: ele.id, text: ele.title, reportDetails: ele });
          });
        case "clientReportTemplate":
          allReportTemplates.clientReportTemplates?.map((ele) => {
            opt.push({ key: ele.id, text: ele.title, reportDetails: ele });
          });
          break;
        case "dsrTemplate":
          allReportTemplates.dsrReportTemplates?.map((ele) => {
            opt.push({ key: ele.id, text: ele.title, reportDetails: ele });
          });
          break;
        default:
          break;
      }
    }
    if (clientReportTemplate != null && clientReportTemplate != undefined && clientReportTemplate == "clientReportTemplate") {
      opt = [];
      allReportTemplates.clientReportTemplates?.map((ele) => {
        opt.push({ key: ele.id, text: ele.title, reportDetails: ele });
      });
    }
    setDropdownSelectedTemplates(opt);
    setDropdownSelectedTemplatesStore(opt);
  };

  const handleUpdateReportSection = (allParentChildReports, studyId) => {
    // console.log(
    //   "--- Changing Report Section ---",
    //   allParentChildReports[studyId]
    // );
    let study = allParentChildReports[studyId];
    if (study != undefined) {
      let opt = [];
      let autoTemplateInd = [];
      study.studyReportList.map((ele) => {
        if (ele.isSuperSpecialReport) {
          let updatedFontSizeReport = convertFontSize(ele.finalReport);
          ele.finalReport = updatedFontSizeReport;
          autoTemplateInd.push(ele);
        } else {
          opt.push({
            key: ele.id,
            text: ele.reportTemplateTitle,
            isSuperSpecialReport: ele.isSuperSpecialReport,
            reportDetails: ele,
            finalReport: ele.finalReport,
            addendum: ele.addendum,
          });
        }
      });
      if (autoTemplateInd != null && autoTemplateInd.length > 0) {
        autoTemplateInd.map((ele, index) => {
          opt.push({
            key: ele.id,
            text: ele.reportTemplateTitle,
            isSuperSpecialReport: ele.isSuperSpecialReport,
            reportDetails: ele,
            finalReport: ele.finalReport,
          });
        });
      }
      // console.log("---- Updating this report ----", autoTemplateInd);
      if (autoTemplateInd != null && autoTemplateInd.length > 0) {
        setChildCurrentActiveTab(
          autoTemplateInd[autoTemplateInd.length - 1]?.text
        );
        setChildModel(autoTemplateInd[autoTemplateInd.length - 1]?.finalReport);
      } else if (opt.length > 0) {
        setChildCurrentActiveTab(opt[opt.length - 1]?.text);
        setChildModel(opt[opt.length - 1]?.finalReport);
      }
      setChildPatientReports(opt);
    }
  };

  const setRaiseAlertListFunc = (raiseAlertList, raiseAlertValue) => {
    let opt = [];
    let object = raiseAlertList;
    if (Object.keys(object)?.length > 0 && object?.hasOwnProperty(raiseAlertValue)) {
      setRaiseAlertValue(object[raiseAlertValue]);
    } else {
      setRaiseAlertValue(raiseAlertValue);
    }
    if (object != null && object != undefined && Object.keys(object)?.length > 0) {
      let keys = Object.keys(object);

      keys.forEach((key, index) => {
        opt.push({ value: key, label: object[key] });
      });
    }

    setRaiseAlertList(opt);
  };

  const getAllReport = async (studyId) => {
    if (isExternal) {
      setLoaderRunning(true);
      ref.current.continuousStart();
    } else {
      setAllReportTemplateLoading(true);
    }

    if (isMobile) return;

    try {
      const ret = await getReportTemplatesData(studyId, firmId);
      if (ret.status === 200) {
        setAllReportTemplateLoading(false);

        if (ret?.data?.data?.dsrReportTemplates?.length > 0) {
          setIsDSRExists(true);
        }

        if (ret?.data?.data?.clientReportTemplates?.length > 0) {
          setIsClientReportExist(true);
          setIsClientReportExistExternalModal(true);
        } else {
          setIsClientReportExist(false);
          setIsClientReportExistExternalModal(false);
        }
        setAllReportTemplates(ret?.data?.data);
        setAgenticReportAgents(ret?.data?.data?.agenticReportAgents || []);
        
        let opt = [];
        let suggestList = [];
        ret.data.data.reportTemplates.map((ele) => {
          if (ele.title == "ELBOW" || ele.title == "HAND") {
            suggestList.push({
              key: ele.id,
              text: ele.title,
              reportDetails: ele,
            });
          }
          opt.push({ key: ele.id, text: ele.title, reportDetails: ele });
        });
        setSuggestedListReport(suggestList);
        setDropdownSelectedTemplates(opt);
        setDropdownSelectedTemplatesStore(opt);
        setAllReportTemplateLoading(false);
      }
    } catch (e) {
      console.log("---Exception---", e);
      setAllReportTemplateLoading(false);
    }
  };

  const handleFistolugramVisiblity = (studyData) => {
    if (
      (roles.includes(USERTYPES.RADIOLOGIST) &&
        (studyData.reportingDoctor == username ||
          studyData.qcFixerId == userId) &&
        studyData.reportDoneStatus != 3 &&
        studyData.reportDoneStatus != 5) ||
      (qcReviewer == 1 &&
        studyData.qcreviewerId == userId &&
        studyData.reportDoneStatus == 3) ||
      (qcReviewer == 1 &&
        studyData.qcverifierId == userId &&
        studyData.reportDoneStatus == 5)
    ) {
      if (studyData.modality == "MR" || studyData.modality == "MRI") {
        setShowFistolugram(true);
      } else {
        setShowFistolugram(false);
      }
      getFistulogramStorageKey(studyData.id);
    } else {
      //hideFistulogramIcons();
      setShowFistolugram(false);
    }
  };

  const getFistulogramStorageKey = async (id) => {
    setFistolugramFilePath(null);
    const response = await getStorageKeyFistolugram(id);
    if (response?.data?.result == "SUCCESS") {
      setFistolugramFilePath(response.data.data);
    }
  };

  const downloadFistolugram = async (fistoAvailable) => {
    setLoaderRunning(true);
    ref.current.continuousStart();
    var filePath = "";
    if (!fistoAvailable) {
      filePath = "REFERENCE_IMAGE/FISTULOGRAM/download.jpg";
    } else if (fistoAvailable) {
      filePath = fistolugramFilePath;
    }
    let response = await downloadFistolugramImage(filePath);
    if (response) {
      setLoaderRunning(false);
      ref.current.complete();
      showToastv2(TOAST_TYPE.SUCCESS, "Fistolugram Downloaded Successfully");
    } else {
      setLoaderRunning(false);
      ref.current.complete();
      showToastv2(TOAST_TYPE.ERROR, "Error while downloading fistolugram");
    }
  };

  const uploadFistolugramFunc = async (studyId, file) => {
    setLoaderRunning(true);
    ref.current.continuousStart();
    try {
      let response = await uploadFistolugramService(studyId, file);
      console.log(response);
      if (response.data.result === "SUCCESS") {
        setLoaderRunning(false);
        ref.current.complete();
        getFistulogramStorageKey(studyId);
        showToastv2(TOAST_TYPE.SUCCESS, "Fistolugram Uploaded Successfully");
      } else {
        setLoaderRunning(false);
        ref.current.complete();
        showToastv2(TOAST_TYPE.ERROR, response.data.message);
      }
    } catch (e) {
      setLoaderRunning(false);
      ref.current.complete();
      console.log("-- Exception ---", e);
      showToastv2(TOAST_TYPE.ERROR, e.message);
    }

  };

  const handleValidationForKeyImagesAndTextAnnotation = (studyData) => {
    // console.log(
    //   roles[0] === USERTYPES.SUPERVISOR &&
    //     (studyData.qcreviewerId === userId ||
    //       studyData.qcverifierId === userId) &&
    //     studyData.allowAddingTextAnnotationAndKeyImage == true
    // );
    // console.log(roles[0])
    // console.log(userId)
    // console.log(studyData.qcreviewerId + " " + studyData.qcverifierId + " " + studyData.allowAddingTextAnnotationAndKeyImage)
    if (roles[0] === USERTYPES.RADIOLOGIST && studyData.peerReviewAssignment?.reviewerId == userId) {
      setShowKeyImagesAndTextAnnotation(false);
    } else if (roles[0] === USERTYPES.RADIOLOGIST ||
      (roles[0] === USERTYPES.SUPERVISOR &&
        (studyData.qcreviewerId === userId ||
          studyData.qcverifierId === userId) &&
        studyData.allowAddingTextAnnotationAndKeyImage == true)
    ) {
      setShowKeyImagesAndTextAnnotation(true);
    } else {
      setShowKeyImagesAndTextAnnotation(false);
    }
    // setShowKeyImagesAndTextAnnotation(true)
  };

  const handleValidation = (studyData) => {
    if (roles[0] == USERTYPES.RADIOLOGIST && userId == studyData.peerReviewAssignment?.reviewerId) {
      setDisableAddendumTab(true);
    } else if (studyData.reportDoneStatus != undefined && studyData?.reportDoneStatus == 2) {
      setDisableAddendumTab(false);
    } else {
      setDisableAddendumTab(true);
    }
    switch (true) {
      case roles.includes(USERTYPES.RADIOLOGIST):
        handleRadiologistValidation(studyData);
        break;

      case !roles.includes(USERTYPES.RADIOLOGIST):
        handleOtherRoleValidation(
          studyData.reportDoneStatus,
          studyData.qcreviewerId,
          studyData.qcverifierId,
          studyData.allowDownloadReport,
          studyData.showWord,
          studyData.enableSubmitForTypist,
          studyData.typistId
        );
        break;

      default:
        break;
    }
    /* in case report saved using word  */
    if (roles[0] == USERTYPES.RADIOLOGIST && userId == studyData.peerReviewAssignment?.reviewerId) {
      if (studyData.peerReviewAssignment?.wordFilePath != undefined && studyData.peerReviewAssignment?.wordFilePath != "") {
        setDisableSave(true);
        setDisableSubmit(true);
        setIsWordFilePath(true);
      }
      else {
        setIsWordFilePath(false);
      }
    } else {
      if (studyData.wordFilePath != undefined && studyData.wordFilePath != "") {
        setDisableSave(true);
        setDisableSubmit(true);
        setIsWordFilePath(true);
      } else {
        setIsWordFilePath(false);
      }
    }

  };

  const handleRadiologistValidation = (studyData) => {
    setDisablePenEye(false);
    setDisableRaiseAlert(false);
    switch (true) {
      //Submitted study
      case studyData.reportDoneStatus == 2:
        handleSubmitValidation(
          studyData.reportingDoctor,
          studyData.allowDownloadReport,
          studyData.peerReviewAssignment
        );
        handleWordValidation(studyData.showWord, studyData.reportingDoctor, studyData.peerReviewAssignment?.reviewerId);
        //handleSaveValidation(studyData.reportingDoctor);
        break;
      case studyData.reportDoneStatus === 4:
        if (studyData.qcfixerId === userId) {
          setDisableQcReason(false);
          setDisableSubmit(false);
          setDisableSubmitUntilQCReasonClick(true);
          if (studyData.showWord != undefined && studyData.showWord == true) {
            setShowMsWord(true);
          }
        } else {
          handleSubmitValidation(
            studyData.reportingDoctor,
            studyData.allowDownloadReport
          );
          handleWordValidation(studyData.showWord, studyData.reportingDoctor);
          // handleSaveValidation(studyData.reportingDoctor);
        }
        setDisableDownload(true);
        setDisablePreview(true);
        break;
      //Saved study
      case studyData.reportDoneStatus === 1:
        handleSaveValidation(studyData.reportingDoctor, studyData.reviewPendingForCTAndMR);
        handleWordValidation(studyData.showWord, studyData.reportingDoctor);
        break;
      default:
        handleUnreportedValidation(studyData.reportingDoctor, studyData.reviewPendingForCTAndMR);
        handleWordValidation(studyData.showWord, studyData.reportingDoctor);
        break;
    }

  };

  const handleOtherRoleValidation = (
    reportDoneStatus,
    qcReviewerId,
    qcVerifierId,
    allowDownloadReportFlag,
    isWordAccess,
    enableSubmitForTypist,
    typistId
  ) => {
    setDisableSubmit(true);
    setDisableSave(true);
    setDisableDownload(true);
    setDisablePreview(true);
    if (
      reportDoneStatus == 2 &&
      (allowDownloadReportFlag || roles.includes(USERTYPES.ADMIN))
    ) {

      setDisableDownload(false);
      setDisablePreview(false);

    } else {
      // setDisableDownload(true);
      // setDisablePreview(true);
      if (roles.includes(USERTYPES.TYPIST)) {
        setDisableDownload(true);
        setDisableSubmit(enableSubmitForTypist ? false : true);
        if (typistId === userId) {
          if ((reportDoneStatus == 0 || reportDoneStatus == 1)) {
            setDisableSave(false);
            if (isWordAccess != undefined && isWordAccess == true) {
              setShowMsWord(true);
            }
            if (reportDoneStatus == 1)
              setDisablePreview(false);
          }
        }
        else {
          setDisableSave(true);
          setShowMsWord(false);
          setDisableSubmit(true);
        }

      }
      if (qcReviewer) {
        if (reportDoneStatus === 3) {
          if (qcReviewerId != undefined && qcReviewerId === userId) {
            setDisableQCPass(false);
            setDisableQCReturn(false);
            setDisableRaiseAlert(false);
            if (isWordAccess != undefined && isWordAccess == true) {
              setShowMsWord(true);
            }
          }
        } else if (reportDoneStatus === 5) {
          if (qcVerifierId != undefined && qcVerifierId === userId) {
            setDisableQCPass(false);
            setDisableQCReturn(false);
            setDisableRaiseAlert(false);
            if (isWordAccess != undefined && isWordAccess == true) {
              setShowMsWord(true);
            }
          }
        }
      }
      if (roles.includes(USERTYPES.FIRMDOCTOR) && privilegedFirmDoctor) {
        if (reportDoneStatus == 1)
          setDisablePreview(false);
      }
    }
  };

  const handleSubmitValidation = (reportingDoctor, allowDownloadReportFlag, peerReviewAssignment) => {
    console.log("handle submit validation");
    if (allowDownloadReportFlag) {
      setDisableDownload(false);
      setDisablePreview(false);
    } else {
      setDisableDownload(true);
      setDisablePreview(true);
    }
    if (reportingDoctor == username && peerReviewAssignment?.reviewerId == null) {
      setDisableSubmit(false);
      setDisableSave(true);
      setDisablePreview(false);
    } else if (userId == peerReviewAssignment?.reviewerId && peerReviewAssignment?.reviewStatus == 1) {
      setDisableDownload(true);
      setDisablePreview(true);
      setDisableSubmit(false);
      setDisableSave(true);
      setDisableRaiseAlert(true);
    } else if (userId == peerReviewAssignment?.reviewerId && peerReviewAssignment?.reviewStatus == 2) {
      setDisableDownload(false);
      setDisablePreview(true);
      setDisableSubmit(true);
      setDisableSave(true);
      setDisableRaiseAlert(true);
    } else {
      setDisableSubmit(true);
      setDisableSave(true);
    }

    if(disableSubmitforResident){
      setDisableSubmit(true);
    }
    
    if(isBvpPlatform) {
      if(reportingDoctor !== username){
        setDisableSave(true);
      }
    }
  };

  const handleSaveValidation = (reportingDoctor, reviewPendingForCTAndMR) => {
    setDisableDownload(true);
    setDisablePreview(true);
    if (reportingDoctor == username) {
      setDisableSubmit(false);
      setDisableSave(false);
      setDisablePreview(false);
    } else {
      setDisableSubmit(true);
      setDisableSave(false);
    }

    if(disableSubmitforResident){
      setDisableSubmit(true);
    }

    if(isBvpPlatform) {
      if(reviewPendingForCTAndMR){
        setDisableSubmit(true);
      }

      if(reportingDoctor !== username){
        setDisableSave(true);
      }
    }
  };

  const handleUnreportedValidation = (reportingDoctor, reviewPendingForCTAndMR) => {
    // console.log("---- HandleUnreportedValidation ----",reportingDoctor);
    setDisableDownload(true);
    setDisablePreview(true);

    switch (true) {
      case reportingDoctor == username:
        setDisableSubmit(false);
        setDisableSave(false);
        break;
      case reportingDoctor == undefined:
        // setHideLockWarningMessage(true);
        // setTimeout(() => {
        setDisableSubmit(true);
        setDisableSave((process.env.REACT_APP_VDC_PLATFORM == "true") ? true : false);
        // }, 1000);
        break;
      default:
        setDisableSubmit(true);
        setDisableSave((process.env.REACT_APP_VDC_PLATFORM == "true") ? true : false);

        break;
    }

    if(disableSubmitforResident){
      setDisableSubmit(true);
    }

    if(isBvpPlatform) {
      if(reviewPendingForCTAndMR){
        setDisableSubmit(true);
      }

      if(reportingDoctor !== username){
        setDisableSave(true);
      }
    }
    
  };

  const handleWordValidation = (isWordAccess, reportingDoctor, reviewerId) => {
    if (isWordAccess && (reportingDoctor == username || userId == reviewerId)) {
      setShowMsWord(true);
    } else {
      setShowMsWord(false);
    }
  };
  const refreshReport = () => {
    setLoaderRunning(true);
    ref.current.continuousStart();
    getData(true);
  };

  const fetchS10Report = async () => {
    setLoaderRunning(true);
    ref.current.continuousStart();

    try {
      let allAddedTabs = patientReports;
      const response = await getS10ReportData(studyParentId);
      if (response.status === 200) {
        console.log(response);
        let obj = {
          finalReport: response.data.data,
          reportTemplateId: allReportTemplates.reportTemplates[0].id,
          reportTemplateTitle: allReportTemplates.reportTemplates[0].title,
          isSuperSpecialReport: 0,
        };
        console.log(allReportTemplates);
        const newKey = allReportTemplates.reportTemplates[0].id;

        // Check if the key already exists in allAddedTabs
        const existingTab = allAddedTabs.find((tab) => tab.key === newKey || tab.reportDetails.reportTemplateId === newKey);
        console.log(existingTab);
        if (!existingTab) {
          allAddedTabs.push({
            key: newKey,
            text: allReportTemplates.reportTemplates[0].title,
            isSuperSpecialReport: 0,
            reportDetails: obj,
          });
        }
        else {
          existingTab.reportDetails.finalReport = obj.finalReport;
          existingTab.reportDetails.report = obj.finalReport;
        }

        console.log(allReportTemplates.reportTemplates[0])
        // console.log(allAddedTabs);
        // console.log(dropdownSelectedTemplates);
        setPatientReports(allAddedTabs);
        handleChangeTemplate(allAddedTabs[0]);
        // console.log(temp);
        // handleChangeTemplate(allReportTemplates.reportTemplates[0]);

        setLoaderRunning(false);
        ref.current.complete();
        showToastv2(TOAST_TYPE.SUCCESS, "S10 Report fetched successfully.");
      }
      else {
        showToastv2(TOAST_TYPE.INFO, response.data.message);
      }
    }
    catch {
      setLoaderRunning(false);
      ref.current.complete();
      showToastv2(TOAST_TYPE.ERROR, "Some Error Occurred.");
    }
    // getData(true);
  };

  const handleRemoveTemplate = (e, removeKey, index) => {
    e.stopPropagation();
    let ind = index - 1;
    if (index - 1 < 0) {
      ind = 0;
    }
    // console.log("Ind is " + ind);
    setPatientReports((current) =>
      current.filter((val) => val.key !== removeKey)
    );
    if (patientReports.length >= 0) {
      setModel(patientReports[ind].text.finalReport);
      // console.log(
      //   patientReports[
      //     ind == 0 ? (patientReports.length >= 1 ? ind + 1 : 0) : ind
      //   ]
      // );
      handleActiveTab(
        patientReports[
        ind == 0 ? (patientReports.length >= 1 ? ind + 1 : 0) : ind
        ]
      );
      setHasUnsavedChanges(false);
    }
  };

  useEffect(() => {
    if (activeTab == 2) {
      patientReports.map((ele, index) => {
        if (currentActiveTab == ele.text) {
          let tempReportDetails =
            ele.reportDetails == undefined ? ele.report : ele.reportDetails;
          if (ele.reportDetails?.report == undefined) {
            setAddendumModel(ele.reportDetails.addendum);
          } else {
            if (ele.reportDetails.addendum != undefined) {
              setAddendumModel(ele.reportDetails.addendum);
            } else {
              setAddendumModel("");
            }
          }
        }
      });
    } else {
      // console.log("Else for active tab"+activeTab)
      patientReports.map((ele, index) => {
        if (currentActiveTab == ele.text) {
          handleChangeTemplate(ele);
        }
      });
    }
  }, [activeTab]);

  const handleModelChange = (model, addendumOrNot) => {
    // console.log("--- Modal Changing ---");
    // setDisableResetReport(false);
    let obj = { updatedValue: model };
    // console.log(obj);
    patientReports.map((ele, index) => {
      if (currentActiveTab == ele.text) {
        let tempReportDetails =
          ele.reportDetails == undefined ? ele.report : ele.reportDetails;
        if (activeTab == 2) {
          if (ele.reportDetails?.report == undefined) {
            if (tempReportDetails?.addendum == undefined) {
              // console.log("Inside 483");
              // console.log(tempReportDetails);
              tempReportDetails["addendum"] = model;
            } else {
              tempReportDetails.addendum = model;
            }
          } else {
            if (tempReportDetails.addendum == undefined) {
              tempReportDetails["addendum"] = model;
            } else {
              tempReportDetails["addendum"] = model;
            }
          }
        } else {
          if (ele.reportDetails?.report == undefined) {
            tempReportDetails.finalReport = model;
          } else {
            tempReportDetails.report = model;
          }
        }
        return { ...ele, reportDetails: tempReportDetails };
      } else {
        return ele;
      }
    });
    if (addendumOrNot == true) {
      setAddendumModel(model);
    } else {
      setModel(model);
    }
  };

  // useEffect(() => {
  //   if (patientReports != undefined) {
  //      console.log("--- Patient Report ---",patientReports);
  //   }
  // }, [patientReports]);

  const handleChangeTemplate = (val) => {
    // console.log("-- HandleChangeTemplate ---");

    let reportDetails =
      val?.reportDetails == undefined ? val.report : val.reportDetails;
    setCurrentActiveTab(
      reportDetails?.report == undefined
        ? reportDetails.reportTemplateTitle
        : reportDetails.title
    );
    setModel(
      reportDetails?.report == undefined
        ? reportDetails?.finalReport
        : reportDetails?.report
    );
    setReportFromAPI(reportDetails?.report == undefined ? reportDetails?.finalReport : reportDetails?.report);
    //Updating the Addendum too
    setAddendumModel(reportDetails?.addendum ?? "");
    setTimeout(() => {
      handleActiveTab(val);
    }, 100);
  };

  const handleChildChangeTemplate = (val) => {
    // console.log("-- HandleChangeTemplate ---");
    setActiveTab(1);
    let reportDetails =
      val?.reportDetails == undefined ? val.report : val.reportDetails;
    setChildCurrentActiveTab(
      reportDetails?.report == undefined
        ? reportDetails.reportTemplateTitle
        : reportDetails.title
    );
    setChildModel(
      reportDetails?.report == undefined
        ? reportDetails?.finalReport
        : reportDetails?.report
    );

    setTimeout(() => {
      handleActiveTab(val);
    }, 100);
  };

  const handleActiveTab = (report) => {
    let element = document.getElementById(report?.text);

    const ulItem = document.getElementById("horizontal-list");
    const listItems = ulItem?.getElementsByTagName("li");
    if (listItems != undefined)
      for (let i = 0; i <= listItems.length - 1; i++) {
        if (listItems[i].id == report?.text) {
          element = listItems[i];
          break;
        }
      }

    if (report != null) {
      if (element != null) {
        if (isStudyList) {
          if (element?.classList != null)
            element?.classList.add(themeName + "-active-li");
        } else {
          if (element?.classList != null) element?.classList.add("active-li");
        }
      }
    }

    if (document.getElementById("horizontal-list") != null) {
      var allTabs = document.getElementById("horizontal-list").children;
      if (allTabs.length > 0) {
        for (var i = 0; i < allTabs.length; i++) {
          if (
            allTabs[i].id != report?.text &&
            report != null &&
            allTabs[i] != null
          ) {
            if (isStudyList) {
              if (allTabs[i].classList.contains(themeName + "-active-li"))
                allTabs[i].classList.remove(themeName + "-active-li");
            } else {
              if (allTabs[i].classList.contains("active-li"))
                allTabs[i].classList.remove("active-li");
            }
          }
        }
      }
    }
  };

  const handleRaiseAlertDropdown = (newVal, val) => {
    if (newVal?.value != null || newVal?.value != undefined) {
      setRaiseAlertValue(newVal.value);
    } else {
      setRaiseAlertValue("");
    }
  };

  const lockStudy = async (val, assignmentData) => {
    if (val == false) {
      setConfirmAlertModal(() => {
        const newItem = { ...confirmAlertModal };
        newItem.show = true;
        newItem.heading = "Alert";
        newItem.type = "lock";
        newItem.description = "Are you sure, you want to lock this study?";
        return newItem;
      });
      return;
    } else if (val == true) {
      setConfirmAlertModal(() => {
        const newItem = { ...confirmAlertModal };
        newItem.show = false;
        newItem.heading = "";
        newItem.type = "";
        newItem.description = "";
        return newItem;
      });
    }
    setLoaderRunning(true);
    ref.current.continuousStart();
    // setShowToast((prev) => {
    //   return {
    //     ...prev,
    //     show: false,
    //     message: "",
    //     loading: true,
    //     state: "success",
    //   };
    // });
    let body = {};
    if (assignmentData.studyId != null) {
      body = {
        studyId: assignmentData.studyId,
        clientId: assignmentData.clientId,
        firmId: assignmentData.firmId,
        assignedProviderId: assignmentData.providerId,
      };
    }

    let res = await assignStudy(true, body);
    if (res.data.result == "SUCCESS") {
      let loaded = await getData(true);
      if (loaded) {
        setLoaderRunning(false);
        ref.current.complete();
      }
      showToastv2(TOAST_TYPE.SUCCESS, "Study Locked Successfully");
    } else {
      setLoaderRunning(false);
      ref.current.complete();
      showToastv2(TOAST_TYPE.ERROR, res?.data?.message != null ? res.data.message : t("study-list.messages.assign-error"));
    }
    // console.log(assignmentData);
  };

  const lockStudySupervisor = async (
    val,
    assignmentData,
    setChangeLockIcon
  ) => {
    // console.log("--- Supervisor assigning --- ");
    setLoaderRunning(true);
    ref.current.continuousStart();

    let body = {};
    if (assignmentData.studyId != null) {
      body = {
        reportingProviderDto: {
          studyId: assignmentData.studyId,
          clientId: assignmentData.clientId,
          firmId: assignmentData.firmId,
          assignedProviderId: (assignmentData.qcreviewerId != null || assignmentData?.qcverifierId != null) ? "S" + userId : false
        },
        isAssign: true,
        isReviewer: assignmentData?.qcreviewerId === null ? true : false,
      };
    }
    const response = await assignMeSupervisor(body);
    if (response.status === 200 && response.data.result === "SUCCESS") {
      let loaded = await getData(true);
      if (loaded) {
        setLoaderRunning(false);
        ref.current.complete();
      }
      setChangeLockIcon(true);
      showToastv2(TOAST_TYPE.SUCCESS, "Study Locked Successfully");
    } else {
      setLoaderRunning(false);
      ref.current.complete();
      showToastv2(TOAST_TYPE.ERROR, "Error while locking study");
    }
  };

  const unlockStudy = async (studyId, isOtherReason, reason, otherReason) => {
    if (reason === "select") {
      setShowModal(() => {
        const newItem = { ...showModal };
        newItem.show = true;
        newItem.type = MODAL_TYPE.ALERT_MODAL;
        newItem.heading = "Alert";
        newItem.isError = false;
        newItem.isSuccess = false;
        newItem.isWarning = true;
        newItem.description = t("string-literals.no-values-selected");
        return newItem;
      });
      return;
    }
    setLoaderRunning(true);
    ref.current.continuousStart();
    setShowReturnStudyModal(false);
    const data = {
      studyId: studyId,
      reasons: isOtherReason ? otherReason : reason,
    };
    // setShowToast((prev) => {
    //   return {
    //     ...prev,
    //     show: false,
    //     message: "",
    //     loading: true,
    //     state: "success",
    //   };
    // });
    // console.log(data);
    const response = await ReturnStudyApi(data);
    if (response.data.result == "SUCCESS") {
      let loaded = await getData(true);
      setLoaderRunning(false);
      ref.current.complete();
      if (loaded)
        showToastv2(TOAST_TYPE.SUCCESS, "Study Unlocked Successfully");
      setTimeout(() => {
        window.close();
      }, 2000);
    } else {
      setLoaderRunning(false);
      ref.current.complete();
      showToastv2(TOAST_TYPE.ERROR, "Error while unlocking study");

    }

    // props.setShowConfirmModal(true);
    // props.setShowReturnStudyResponse(true);
    // props.setReturnStudyResponseMsg(response.data.message);
  };

  const releaseStudy = async (studyId) => {
    console.log("releasing study", studyId);
    setLoaderRunning(true);
    ref.current.continuousStart();
    const response = await ReleaseStudyApi(studyId);
    if (response.data.result == "SUCCESS") {
      let loaded = await getData(true);
      setLoaderRunning(false);
      ref.current.complete();
      if (loaded)
        showToastv2(TOAST_TYPE.SUCCESS, "Study Released Successfully");
      setTimeout(() => {
        window.close();
      }, 2000);
    } else {
      setLoaderRunning(false);
      ref.current.complete();
      showToastv2(TOAST_TYPE.ERROR, "Error while releasing study");
    }
  };

  const handleAnnotationJsonData = (data) => {
    // console.log(data);
    let tempAnnotation = [];
    if (data != null && data.length > 0) {
      data.map((item, index) => {
        //  console.log("Item is ");
        //  console.log(item);
        if (item.is_annotated == true && item.is_locked == true)
          tempAnnotation.push(item.id);
      });
    }
    // console.log(tempAnnotation.toString());
    setAnnotationsJson("[" + tempAnnotation.toString() + "]");
  };

  useEffect(() => {
    // console.log("ANnotaiton "+annotationsJson);
  }, [annotationsJson]);

  const handleDropdown = (newVal, val) => {
    if (patientReports.find((e) => e.text === newVal.text)) {
      handleChangeTemplate(newVal);
      setReset(true);
      return;
    }
    setPatientReports((current) => [...current, newVal]);
    setReset(true);
  };

  useEffect(() => {
    // console.log("Report state");
    // console.log(reportModalState);
  }, [reportModalState]);

  const handleDropdownWithContext = (newVal, isRSNAModal) => {
    console.log("-- HandleDropDownWithContext ---", patientReports);
    console.log("newVal", newVal);
    console.log("radiologist,", roles[0] === USERTYPES.RADIOLOGIST);
    console.log("vdc,", (process.env.REACT_APP_VDC_PLATFORM == "true" || process.env.REACT_APP_VDC_PLATFORM == true));
    if (patientReports.length >= 1 && !patientReports.some(report => report.key === newVal.key || report.reportDetails.reportTemplateId === newVal.key)
      && roles[0] === USERTYPES.RADIOLOGIST
      && (process.env.REACT_APP_VDC_PLATFORM == "true" || process.env.REACT_APP_VDC_PLATFORM == true)) {

      console.log("Displaying confirmation popup");
      setConfirmMultipleTemplateModalContent({
        header: (
          <ModalHeader
            heading="Alert"
            updatedModal={true}
            handleCancel={() => {
              setConfirmMultipleTemplateOpen(false);
            }}
          />
        ),
        body: (
          <div className="return-study-container">
            <div className="return-study-content">
              <div className="ReturnStudyContentContainer">
                <div className="content-1">
                  <p style={{ fontWeight: "bold" }}>Do you want to open another template ?</p>
                </div>
              </div>
            </div>
          </div>
        ),
        footer: (
          <ModalFooter
            PrimaryButtonList={[
              {
                title: 'Yes',
                onclick: () => {
                  setConfirmMultipleTemplateOpen(false);
                  handleDropdownWithContextUpdated(newVal, isRSNAModal);
                },
              },
            ]}
            DefaultButtonList={[
              {
                title: 'No',
                onclick: () => {
                  setConfirmMultipleTemplateOpen(false);
                },
              },
            ]}
          />
        ),
        width: "400px",
      });
      setConfirmMultipleTemplateOpen(true);
      return;
    }

    handleDropdownWithContextUpdated(newVal, isRSNAModal);
  }

  const handleDropdownWithContextUpdated = (newVal, isRSNAModal) => {
    console.log("-- HandleDropDownContext updated ---", patientReports);
    if (newVal.text == REPORT_TITLE.HRCT_CHEST_ILD) {
      setReportModalState(() => {
        const newItem = { ...reportModalState };
        newItem.hrctChestILD = true;
        newItem.hrctChestCovid = false;
        newItem.ctBrain = false;
        newItem.content = newVal;
        newItem.id = newVal.key;
        return newItem;
      });
      return;
    } else if (newVal.text == REPORT_TITLE.CT_BRAIN) {
      setReportModalState(() => {
        const newItem = { ...reportModalState };
        newItem.hrctChestILD = false;
        newItem.hrctChestCovid = false;
        newItem.ctBrain = true;
        newItem.content = newVal;
        newItem.id = newVal.key;
        return newItem;
      });
      return;
    } else if (newVal.text == REPORT_TITLE.HRCT_CHEST_COVID) {
      setReportModalState(() => {
        const newItem = { ...reportModalState };
        newItem.hrctChestILD = true;
        newItem.hrctChestCovid = false;
        newItem.ctBrain = false;
        newItem.content = newVal;
        newItem.id = newVal.key;
        return newItem;
      });
      return;
    } else if (newVal.text == REPORT_TITLE.HRCT_CHEST_COVID_SR) {
      setReportModalState(() => {
        const newItem = { ...reportModalState };
        newItem.hrctChestCovid = true;
        newItem.hrctChestILD = false;
        newItem.ctBrain = false;
        newItem.content = newVal;
        newItem.id = newVal.key;
        return newItem;
      });
      return;
    } else if (newVal.text == REPORT_TITLE.MRI_SPINE_SR) {
      setReportModalState(() => {
        const newItem = { ...reportModalState };
        newItem.hrctChestCovid = false;
        newItem.hrctChestILD = false;
        newItem.ctBrain = false;
        newItem.mriSpine = true;
        newItem.content = newVal;
        newItem.id = newVal.key;
        return newItem;
      });
      return;
    }

    if (isRSNAModal) {
      setOpenRSNAModal(true);
      // console.log(newVal);
      let item = dropdownSelectedTemplates.filter((ele, index) => {
        if (ele.text == newVal.text) {
          return ele;
        }
      });
      // console.log(item);
      setRSNAModalContent(item[0]);
      return;
    }
    if (patientReports.length == 0) {
      handleChangeTemplate(newVal);
      setFirstReportAdded(true);
    }
    if (selectedCategoryTemplate === "dsrTemplate") {
      const anyDSRTemplate = patientReports.filter(report => report.text.includes("LLM"));
      if (anyDSRTemplate.length !== 0) {
        setPatientReports([]);
      } else {
        setOldPatientReports(patientReports);
        setPatientReports([]);
      }

    } else {
      const anyDSRTemplate = patientReports.filter(report => report.text.includes("LLM"));
      if (anyDSRTemplate.length !== 0) {
        setPatientReports(oldPatientReports);
        setOldPatientReports(anyDSRTemplate);
      }
    }

    if (patientReports.find((e) => e.text === newVal.text)) {
      handleChangeTemplate(newVal);
      return;
    } else {
      if (selectedCategoryTemplate === "dsrTemplate" && newVal.text.includes("Other")) {
        setDisableObservations(true);
        setActiveTab(1);
      } else {
        setDisableObservations(false);
      }
      setPatientReports((current) => [...current, newVal]);
    }
  };

  const downloadReport = async (type, studyId) => {
    if (studyId == null || studyId == undefined) {
      studyId = studyParentId;
    }
    setLoaderRunning(true);
    ref.current.continuousStart();
    // setShowToast((prev) => {
    //   return {
    //     ...prev,
    //     show: false,
    //     message: "",
    //     loading: true,
    //     state: "success",
    //   };
    // });
    logAmplitudeEventForReport(type, studyId);
    try {
      let res = await downloadPdfReport(studyId, type);
      // console.log(res);
      if (res.status == 200 && res.data.result === "SUCCESS") {
        setLoaderRunning(false);
        ref.current.complete();
        if (res.data.data.paymentStatus == VDCLIMS.PaymentStatusCodes.PAID) {
          showToastv2(TOAST_TYPE.SUCCESS, "Download Successful");
        }
        if (
          res.data.data.paymentStatus == VDCLIMS.PaymentStatusCodes.DUE ||
          res.data.data.paymentStatus == VDCLIMS.PaymentStatusCodes.ERROR
        ) {
          setAlertSuccessModal(() => {
            const newItem = { ...alertSuccessModal };
            newItem.show = true;
            newItem.heading = "Alert";
            newItem.description =
              res.data.data.paymentStatus == VDCLIMS.PaymentStatusCodes.DUE
                ? t("payment-status.payment-due-message")
                : t("payment-status.payment-error-message");
            return newItem;
          });
        }
      } else {
        // alert("Something goes wrong");
        setLoaderRunning(false);
        ref.current.complete();
        showToastv2(TOAST_TYPE.ERROR, t("string-literals.error-msg"));
      }
    } catch (e) {
      setLoaderRunning(false);
      ref.current.complete();
      showToastv2(TOAST_TYPE.ERROR, t("string-literals.error-msg"));
    }
  };

  /* 
    Author: Tushar Saxena 
    Description: Download AI report
    Date: 02-02-2024 
  */
  const downloadAIReport = async (studyId) => {
    // console.log("In Download AI report");
    // console.log("Study Id", studyId);
    if (studyId == null || studyId == undefined) {
      studyId = studyParentId;
    }
    setLoaderRunning(true);
    ref.current.continuousStart();
    // logAmplitudeEventForReport(type, studyId);
    try {
      let res = await downloadAIReportAPI(studyId);

      if (res.status == 200 && res.data.result === "SUCCESS") {
        setLoaderRunning(false);
        ref.current.complete();
        showToastv2(TOAST_TYPE.SUCCESS, "Download Successful");
      } else {
        setLoaderRunning(false);
        ref.current.complete();
        showToastv2(TOAST_TYPE.ERROR, t("string-literals.error-msg"));
      }
    } catch (e) {
      setLoaderRunning(false);
      ref.current.complete();
      showToastv2(TOAST_TYPE.ERROR, t("string-literals.error-msg"));
    }
  };

  const logAmplitudeEventForReport = (type, studyId) => {
    if (type === "docx") {
      let eventProperties = {
        TYPE: "DOCX",
        "STUDY ID": studyId,
      };
      logAmplitudeEventWithUsernameAndRole(
        "EVENT_BASIC_DOWNLOAD_REPORT_DOCX",
        eventProperties,
        username
      );
    } else if (type === "doc") {
      let eventProperties = {
        TYPE: "DOC",
        "STUDY ID": studyId,
      };
      logAmplitudeEventWithUsernameAndRole(
        "EVENT_BASIC_DOWNLOAD_REPORT_DOC",
        eventProperties,
        username
      );
    } else if (type === "pdf") {
      let eventProperties = {
        TYPE: "PDF",
        "STUDY ID": studyId,
      };
      logAmplitudeEventWithUsernameAndRole(
        "EVENT_BASIC_DOWNLOAD_REPORT_PDF",
        eventProperties,
        username
      );
    } else if (type === "pdfwithimage") {
      let eventProperties = {
        TYPE: "PDF WITH IMAGE",
        "STUDY ID": studyId,
      };
      logAmplitudeEventWithUsernameAndRole(
        "EVENT_BASIC_DOWNLOAD_REPORT_PDF_WITH_IMAGE",
        eventProperties,
        username
      );
    }
  };

  const handlePreviewReport = async (studyParamId, reportDoneStatus) => {
    setLoaderRunning(true);
    ref.current.continuousStart();
    // setShowToast((prev) => {
    //   return { ...prev, show: false, message: "", loading: true };
    // });
    // console.log("Study Id, ",studyParamId,studyId);
    try {
      let actualStudyId = (studyParamId && studyParamId.nativeEvent) ? studyId : studyParamId;
      let reportStatus = reportDoneStatus != null && reportDoneStatus != undefined ? reportDoneStatus : reportDoneStatusState;
      console.log("reportDoneStatus------- while previewing the report in state file", reportStatus, actualStudyId);
      let res = await previewPdfReport(actualStudyId, reportStatus);
      if (res?.data?.result === "SUCCESS") {
        if (res.data.data.paymentStatus == VDCLIMS.PaymentStatusCodes.PAID) {
          // showToastv2(TOAST_TYPE.SUCCESS, "Preview Successfull");
        }
        setLoaderRunning(false);
        ref.current.complete();
        if (reportStatus == REPORTDONESTATUS.REPORTED &&
          (res.data.data.paymentStatus == VDCLIMS.PaymentStatusCodes.DUE ||
            res.data.data.paymentStatus == VDCLIMS.PaymentStatusCodes.ERROR)
        ) {
          setAlertSuccessModal(() => {
            const newItem = { ...alertSuccessModal };
            newItem.show = true;
            newItem.heading = "Alert";
            newItem.description =
              res.data.data.paymentStatus == VDCLIMS.PaymentStatusCodes.DUE
                ? t("payment-status.payment-due-message")
                : t("payment-status.payment-error-message");
            return newItem;
          });
        }
      } else {
        setLoaderRunning(false);
        ref.current.complete();
        showToastv2(TOAST_TYPE.ERROR, t("string-literals.error-msg"));
      }
    } catch (e) {
      setLoaderRunning(false);
      ref.current.complete();
      showToastv2(TOAST_TYPE.ERROR, t("string-literals.error-msg"));
    }
  };

  const handlePreviewReportVersion = async (versionParamId) => {
    setLoaderRunning(true);
    ref.current.continuousStart();
    try {
      let res = await previewPdfReportVersion(versionParamId);
      if (res?.data?.result === "SUCCESS") {
        if (res.data.data.paymentStatus == VDCLIMS.PaymentStatusCodes.PAID) {
          // showToastv2(TOAST_TYPE.SUCCESS, "Preview Successfull");
        }

        setLoaderRunning(false);
        ref.current.complete();
        if (
          res.data.data.paymentStatus == VDCLIMS.PaymentStatusCodes.DUE ||
          res.data.data.paymentStatus == VDCLIMS.PaymentStatusCodes.ERROR
        ) {
          setAlertSuccessModal(() => {
            const newItem = { ...alertSuccessModal };
            newItem.show = true;
            newItem.heading = "Alert";
            newItem.description =
              res.data.data.paymentStatus == VDCLIMS.PaymentStatusCodes.DUE
                ? t("payment-status.payment-due-message")
                : t("payment-status.payment-error-message");
            return newItem;
          });
        }
      } else {
        setLoaderRunning(false);
        ref.current.complete();
        showToastv2(TOAST_TYPE.ERROR, t("string-literals.error-msg"));
      }
    } catch (e) {
      setLoaderRunning(false);
      ref.current.complete();
      showToastv2(TOAST_TYPE.ERROR, t("string-literals.error-msg"));
    }
  };

  // const validateQCPass = async(studyId,)

  const handleQcPass = async (
    studyId,
    keyImages,
    qcData,
    allTextToolData,
    checkKeyImagesAndTextAnnotation = true
  ) => {

    if (checkKeyImagesAndTextAnnotation) {
      if (
        keyImagesPresent(keyImages) &&
        Object.keys(allTextToolData).length !== 0
      ) {
        setIsKeyImagesPresent(true);
        setIsTextAnnotationPresent(true);
        setOpenQCPassConfirmModal(true);
        return;
      }

      if (keyImagesPresent(keyImages)) {
        setIsKeyImagesPresent(true);
        setOpenQCPassConfirmModal(true);
        return;
      }
      if (Object.keys(allTextToolData).length !== 0) {
        setIsTextAnnotationPresent(true);
        setOpenQCPassConfirmModal(true);
        return;
      }
    }
    const qcParams = {
      studyId,
      keyImages,
      qcData,
      allTextToolData,
      checkKeyImagesAndTextAnnotation,
    };

    setQCPassParams(qcParams);

    if (reportDoneStatusState !== 2 && formatterAgentEnabled && !formattedReportUsed && !isExternal && conflictSave == "0") {
      console.log("Formatter Agent is enabled for QC supervisor", showFormatterPopup);
      setPendingQCPass(() => proceedWithQCPass);
      setShowFormatterPopup(true);
      return;
    }
    console.log("Formatter Agent is enabled for QC supervisor");
    proceedWithQCPass(qcParams);
  }

  const proceedWithQCPass = async (qcParams) => {
    console.log("QC Pass params", qcPassParams, qcParams);
    if (!qcPassParams && !qcParams) return;

    console.log("Proceed with QC Pass")
    let data = !qcPassParams ? qcParams : qcPassParams;

    const requestData = {
      studyId: data.studyId,
      clientId: data.qcData.clientId,
      firmId: data.qcData.firmId,
      providerId: 0,
      reasons: "",
      raiseAlert: raiseAlertValue,
      studyKeyImages: data.keyImages,
      imageToolAnnotationMeasurements: [],
      studyReportList: await getFormattedReports(),
      conflictSave: conflictSave,
      formattedReportAction: formattedReportAction
    };

    setLoaderRunning(true);
    ref.current.continuousStart();

    const response = await submitQC(requestData, data.allTextToolData);
    // console.log(response);
    if (response.status === 200) {
      setLoaderRunning(false);
      ref.current.complete();

      if (reportDoneStatusState === 3) {
        showToastv2(TOAST_TYPE.SUCCESS, "QC Review Successful !");
      } else {
        showToastv2(TOAST_TYPE.SUCCESS, "QC Verify Successful !");
      }
      setTimeout(() => {
        window.close();
      }, 2000);
    } else {
      setLoaderRunning(false);
      ref.current.complete();
      if (response.data.result == "FAILURE") {
        if (
          response?.data?.message != null &&
          response?.data?.message?.includes(
            "Found conflict in patient sex and report content in"
          )
        ) {
          let conflictSaveTemp = response?.data?.message?.includes(
            "Found conflict in patient sex and report content in"
          )
            ? "1"
            : "0";
          setConflictSave("1");
          if (conflictSaveTemp == "1") {
            setConfirmAlertModal(() => {
              const newItem = { ...confirmAlertModal };
              newItem.isConflictPopup = true;
              newItem.show = true;
              newItem.type = "qcPass";
              newItem.heading = "Alert";
              newItem.description = response.data.message;
              newItem.qcData = data.qcData;
              newItem.allTextToolData = data.allTextToolData;
              newItem.checkKeyImagesAndTextAnnotation = data.checkKeyImagesAndTextAnnotation;
              return newItem;
            });
          }
        } else {
          showToastv2(TOAST_TYPE.ERROR, "QC Verify Failed");
        }
      } else if (reportDoneStatusState == 3) {
        showToastv2(TOAST_TYPE.ERROR, "QC Review Failed");
      } else {
        showToastv2(TOAST_TYPE.ERROR, "QC Verify Failed");
      }
    }
  };

  const validateQCFields = (
    qcReason,
    otherReason,
    providerId,
    setIsError,
    setErrorMessage
  ) => {
    // console.log(qcReason);
    if (qcReason === null || qcReason === "") {
      setIsError(true);
      setErrorMessage(t("QC.specify-reason"));
      return false;
    } else if (
      qcReason === "Other" &&
      (otherReason === null || otherReason === undefined || otherReason === "")
    ) {
      setIsError(true);
      setErrorMessage(t("QC.specify-other-reason"));
      return false;
    } else if (
      providerId === null ||
      providerId === undefined ||
      providerId === ""
    ) {
      setIsError(true);
      setErrorMessage(t("QC.select-qc-radiologist"));
      return false;
    }
    return true;
  };

  const handleQCReasonClick = async () => {
    setDisableSubmitUntilQCReasonClick(false);
  };

  const handleQcReturn = async (
    studyId,
    qcData,
    keyImages,
    qcReason,
    otherReason,
    providerId,
    setIsError,
    setErrorMessage,
    allTextToolData
  ) => {
    if (
      !validateQCFields(
        qcReason,
        otherReason,
        providerId,
        setIsError,
        setErrorMessage
      )
    ) {
      return;
    }

    const requestData = {
      studyId: studyId,
      clientId: qcData.clientId,
      firmId: qcData.firmId,
      providerId: providerId,
      reasons: qcReason === "Other" ? otherReason : qcReason,
      raiseAlert: raiseAlertValue,
      studyKeyImages: keyImages,
      imageToolAnnotationMeasurements: [],
      // studyReportList : await getFormattedReports(),
    };
    setLoaderRunning(true);
    ref.current.continuousStart();
    const response = await submitQC(requestData, allTextToolData);
    if (response.status === 200 && response.data.result === "SUCCESS") {
      setLoaderRunning(false);
      ref.current.complete();
      showToastv2(TOAST_TYPE.SUCCESS, "QC Return Successful !");
      setTimeout(() => {
        window.close();
      }, 2000);
    } else {
      //showToastv2(TOAST_TYPE.ERROR, "QC Return Failed");
      setLoaderRunning(false);
      ref.current.complete();
      setAlertSuccessModal(() => {
        const newItem = { ...alertSuccessModal };
        newItem.show = true;
        newItem.heading = "Error";
        newItem.description = t("string-literals.error-msg");
        return newItem;
      });
    }
  };

  const getConsistentDateFormat = (date) => {
    const momentDate = Moment(date, "DD-MMM-YY HH:mm", true); // Adjusted the format

    if (momentDate.isValid()) {
      return momentDate.format("DD-MMM-YY hh:mm A");
    } else {
      return "No Date";
    }
  };

  const getConsistentCustomDateFormat = (date) => {
    if (!date) return "No Date";

    let momentDate;

    if (Moment(date, Moment.ISO_8601, true).isValid()) {
      momentDate = Moment(date);
    }
    else if (Moment(date, "DD-MMM-YY HH:mm", true).isValid()) {
      momentDate = Moment(date, "DD-MMM-YY HH:mm");
    }
    else {
      return "No Date";
    }
    return momentDate.format("DD-MMM-YY hh:mm A");


    // const momentDate = Moment(date, "DD-MMM-YY HH:mm", true); // Adjusted the format

    // if (momentDate.isValid()) {
    //   return momentDate.format("DD-MMM-YY hh:mm A");
    // } else {
    //   return date;
    // }
  };

  const handleQcReturnButtonClick = async (studyId, qcData) => {
    const response = await getQCProvidersList({
      studyId: studyId,
      clientId: qcData.clientId,
      firmId: qcData.firmId,
    });
    const radiologistList = response.data.data.radiologists;
    const providerList = response.data.data.providers;
    let tempProviderList = [];

    providerList.forEach((provider) => {
      tempProviderList.push({
        value: "F" + provider.id,
        label:
          provider.qcType === ""
            ? provider.name
            : provider.qcType + " - " + provider.name,
      });
    });

    radiologistList.forEach((provider) => {
      tempProviderList.push({
        value: "R" + provider.id,
        label:
          provider.qcType === ""
            ? provider.firstName + " " + provider.lastName
            : provider.qcType +
            " - " +
            provider.firstName +
            " " +
            provider.lastName,
      });
    });

    setQcProviderList(tempProviderList);

    setOpenQcModal(true);
  };

  const checkIfCancelOrNot = (
    val,
    keyImages,
    annotationData,
    annotationDataAI,
    allTextToolAnnotation,
    activeViewportIndex,
    passConflictTemp,
    qcData,
  ) => {
    if (confirmAlertModal.type == "qcPass") {
      handleQcPass(
        studyParentId,
        keyImages,
        qcData,
        allTextToolAnnotation,
        false
      )
    }
    else if (confirmAlertModal.type == "save") {
      handleSaveReport(
        val,
        keyImages,
        annotationData,
        annotationDataAI,
        allTextToolAnnotation,
        activeViewportIndex,
        passConflictTemp
      );
    } else {
      let addendumDisclaimerAddedByRadVal = false;
      let showAddendumDisclaimerPopupVal = false;
      handleSubmitReport(
        val,
        keyImages,
        annotationData,
        annotationDataAI,
        allTextToolAnnotation,
        activeViewportIndex,
        passConflictTemp,
        addendumDisclaimerAddedByRad,
        showAddendumDisclaimerPopupVal
      );
    }

    setConfirmAlertModal(() => {
      const newItem = { ...confirmAlertModal };
      newItem.show = false;
      newItem.heading = "";
      newItem.description = "";
      newItem.type = "save";
      return newItem;
    });
    // console.log("Inside checkIfCancelOrNot "+val);
  };

  const handleSaveReport = async (
    state,
    keyImages,
    annotationData,
    annotationDataAI,
    allTextToolAnnotation,
    activeViewportIndex,
    passConflictTemp,
    formattedReportAction,
    updatedReports
  ) => {
    if (enableReportRegenerate == true && !isClientReportExist) {
      setConfirmAlertModal(() => {
        const newItem = { ...confirmAlertModal };
        newItem.show = true;
        newItem.type = "save";
        newItem.heading = "Alert";
        newItem.description =
          "There are unsaved changes. Are you sure you want to continue without regenerating report ?";
        return newItem;
      });
      if (state == true) {
        return;
      }
    }
    setLoaderRunning(true);
    setExternalReportingLoading(true);
    ref.current.continuousStart();
    try {
      let body = await getFormatedData(
        keyImages,
        annotationData,
        annotationDataAI,
        allTextToolAnnotation,
        activeViewportIndex,
        passConflictTemp,
        false,
        formattedReportAction,
        updatedReports
      );
      //checking the body after formating=========================
      console.log("body inside the formating the request=======", body);
      if (body == null) {
        // console.log("Inside special empty check");
        setLoaderRunning(false);
        ref.current.complete();
        return;
      }
      if (body?.loaded == true && body?.content == null) {
        //showToastv2(TOAST_TYPE.ERROR, t("string-literals.goesWrong"))
        setLoaderRunning(false);
        ref.current.complete();
        setExternalReportingLoading(false);
        setAlertSuccessModal(() => {
          const newItem = { ...alertSuccessModal };
          newItem.show = true;
          newItem.heading = "Alert";
          newItem.description =
            patientReports.length == 0
              ? t("string-literals.no-reports-added")
              : t("string-literals.empty-report");
          return newItem;
        });
        return;
      } else if (body.loaded == true && body.content != null) {

        let response = await saveReportTemplatesData(body.content);
        console.log("body content coming after api call ===========", response);
        if (
          (response.status === 200 && (response.data.result == "SUCCESS" || response.data.result == "WARNING")) ||
          (passConflictTemp != null &&
            passConflictTemp == true &&
            response.status === 200 &&
            (response.data.result == "SUCCESS" || response.data.result == "WARNING"))
        ) {
          // console.log("Going in this");
          let eventProperties = {};
          logAmplitudeEventWithUsernameAndRole(
            "EVENT_BASIC_SAVE_REPORT",
            eventProperties,
            username
          );
          getData(false, false);
          if (!isExternal) {
            setReportSaveSuccess((prev) => !prev);
          } else {
            //setOpenReportModal(false);
            if (roles[0] == USERTYPES.TYPIST) {
              setIsExternal(false);
              setIsClientReportExistExternalModal(null);
              setUpdateDoneSubmitDone(() => {
                const newItem = { ...updateRowSubmitDone };
                newItem.id = studyId;
                newItem.show = true;
                return newItem;
              });
              setOpenReportModal(false);
            }
          }
          if (response.data.result == "WARNING") {
            showToastv2(
              TOAST_TYPE.INFO,
              response.data.message
            );
          }
          setLoaderRunning(false);
          ref.current.complete();
          showToastv2(TOAST_TYPE.SUCCESS, t("string-literals.save-report"));
          setExternalReportingLoading(false);

        } else if (response.data.result == "FAILURE") {
          // console.log("Second if");
          if (
            response?.data?.message != null &&
            response?.data?.message?.includes(
              "Found conflict in patient sex and report content in"
            )
          ) {
            let conflictSaveTemp = response?.data?.message?.includes(
              "Found conflict in patient sex and report content in"
            )
              ? "1"
              : "0";
            setConflictSave("1");

            if (conflictSaveTemp == "1")
              setConfirmAlertModal(() => {
                const newItem = { ...confirmAlertModal };
                newItem.isConflictPopup = true;
                newItem.show = true;
                newItem.type = "save";
                newItem.heading = "Alert";
                newItem.description = response.data.message;
                return newItem;
              });
          } else {
            // console.log("--- Checking For Save Report ---", response);
            switch (true) {
              case response.data.message ==
                t("string-literals.study-already-submitted"):
                setAlertSuccessModal(() => {
                  const newItem = { ...alertSuccessModal };
                  newItem.show = true;
                  newItem.heading = "Alert";
                  newItem.description = response.data.message;
                  return newItem;
                });
                break;
              case response.data.message ==
                t("string-literals.study-already-saved-form-msword"):
                setAlertSuccessModal(() => {
                  const newItem = { ...alertSuccessModal };
                  newItem.show = true;
                  newItem.heading = "Alert";
                  newItem.description = response.data.message;
                  return newItem;
                });
                break;
              case response.data.message ==
                t("string-literals.typist-cannot-save-study"):
                setAlertSuccessModal(() => {
                  const newItem = { ...alertSuccessModal };
                  newItem.show = true;
                  newItem.heading = "Alert";
                  newItem.description = response.data.message;
                  return newItem;
                });
                break;
              case response.data.message ==
                t(
                  "string-literals.study-can-not-save-study-assigned-to-other-radiologist"
                ):
                setAlertSuccessModal(() => {
                  const newItem = { ...alertSuccessModal };
                  newItem.show = true;
                  newItem.heading = "Alert";
                  newItem.description = response.data.message;
                  return newItem;
                });
                break;
              case response.data.message ==
                t(
                  "string-literals.can-not-save-or-submit-expired-study"
                ):
                setAlertSuccessModal(() => {
                  const newItem = { ...alertSuccessModal };
                  newItem.show = true;
                  newItem.heading = "Alert";
                  newItem.description = response.data.message;
                  return newItem;
                });
                break;
              case response.data.message ==
                t(
                  "string-literals.can-not-save-closed-study"
                ):
                setAlertSuccessModal(() => {
                  const newItem = { ...alertSuccessModal };
                  newItem.show = true;
                  newItem.heading = "Alert";
                  newItem.description = response.data.message;
                  return newItem;
                });
                break;
              case response.data.message ==
                t(
                  "string-literals.can-not-save-closed-study"
                ):
                setAlertSuccessModal(() => {
                  const newItem = { ...alertSuccessModal };
                  newItem.show = true;
                  newItem.heading = "Alert";
                  newItem.description = response.data.message;
                  return newItem;
                });
                break;
              default:
                setAlertSuccessModal(() => {
                  const newItem = { ...alertSuccessModal };
                  newItem.show = true;
                  newItem.heading = "Error";
                  newItem.description = t("string-literals.error-msg");
                  return newItem;
                });
                break;
            }
          }
          setLoaderRunning(false);
          ref.current.complete();
          setExternalReportingLoading(false);
        }
      }
    } catch (e) {
      setLoaderRunning(false);
      ref.current.complete();
      showToastv2(
        TOAST_TYPE.ERROR,
        t("string-literals.error-msg") + " Error Log: " + e.message
      );
    }
  };

  const isAddendumTextPresentInReport = () => {
    let isAddendumTextPresent = false;
    let poweredByFroalaRegex =
      /<p[^>]*>\s*Powered by\s*<a[^>]*>Froala Editor<\/a>\s*<\/p>/gi;
    patientReports.map((ele, index) => {
      ele.reportDetails == undefined
        ? (ele.reportDetails = ele.report)
        : (ele.reportDetails = ele.reportDetails);
      if (ele.reportDetails != undefined && ele.reportDetails != null) {
        if (
          ele.reportDetails.addendum !== "" &&
          ele.reportDetails.addendum != undefined
        ) {
          let modifiedHtmlString = ele.reportDetails.addendum;
          if (poweredByFroalaRegex.test(ele.reportDetails.addendum)) {
            // console.log("--- Present Powered by text (addendum) ----");
            modifiedHtmlString = ele.reportDetails.addendum.replace(
              poweredByFroalaRegex,
              ""
            );
          }
          // console.log("modifiedHtmlString------>", modifiedHtmlString);
          if (modifiedHtmlString !== "") {
            isAddendumTextPresent = true;
          }
        }
      }
    });
    return isAddendumTextPresent;
  };

  const handleSubmitReport = async (
    state,
    keyImages,
    annotationData,
    annotationDataAI,
    allTextToolAnnotation,
    activeViewportIndex,
    passConflictTemp,
    addendumDisclaimerAddedByRadVal,
    showAddendumDisclaimerPopupVal,
    formattedReportAction,
    updatedReports
  ) => {
    if (enableReportRegenerate == true && !isClientReportExist) {
      setConfirmAlertModal(() => {
        const newItem = { ...confirmAlertModal };
        newItem.show = true;
        newItem.type = "submit";
        newItem.heading = "Alert";
        newItem.description =
          "There are unsaved changes. Are you sure you want to continue without regenerating report ?";
        return newItem;
      });
      if (state == true) {
        return;
      }
    }
    let isAddendumTextPresent = isAddendumTextPresentInReport();
    setShowAddendumDisclaimerPopup(showAddendumDisclaimerPopupVal);
    // console.log(
    //   "isAddendumTextPresent=" + isAddendumTextPresent,
    //   "showAddendumDisclaimerPopupVal=" +
    //     showAddendumDisclaimerPopupVal +
    //     " showAddendumDisclaimerPopup=" +
    //     showAddendumDisclaimerPopup +
    //     " addendumDisclaimerAddedByRadVal=" +
    //     addendumDisclaimerAddedByRadVal
    // );
    if (forceReinferenceInProgress) {
      setShowForceReinferenceModal(true);
      return;
    }
    if (
      isAddendumTextPresent &&
      addendumDisclaimerEnabled &&
      showAddendumDisclaimerPopup
    ) {
      setShowConfirmModal(true);
      setShowAddendumDisclaimerModal(true);
      return;
    }
    setAddendumDisclaimerAddedByRad(addendumDisclaimerAddedByRadVal); //state didn't get updated
    console.log("setReportDoneStatusState=" + reportDoneStatusState);

    if (reportDoneStatusState === 2
      && (process.env.REACT_APP_VDC_PLATFORM == "true" || process.env.REACT_APP_VDC_PLATFORM == true)
      && userId != reviewerId
    ) {
      setConfirmAlertModal(() => {
        const newItem = { ...confirmAlertModal };
        newItem.show = true;
        newItem.type = "resubmit";
        newItem.heading = "Alert";
        newItem.description =
          "This report has already been submitted. If you still want to proceed, click 'Yes' Otherwise, click 'No'. Please remember to use the amendment format when making changes to any report.";
        return newItem;
      });
      if (state == true) {
        return;
      }
    }

    const submissionData = {
      keyImages,
      annotationData,
      annotationDataAI,
      allTextToolAnnotation,
      activeViewportIndex,
      passConflictTemp,
      addendumDisclaimerAddedByRadVal,
      formattedReportAction,
      updatedReports
    };

    setSubmissionParams(submissionData);


    if ((patientReports.length == 0 && updatedReports?.length == 0) || !checkReportContent(updatedReports)) {
      console.log("Content is not present")
      setLoaderRunning(false);
      ref.current.complete();
      setExternalReportingLoading(false);
      setAlertSuccessModal(() => {
        const newItem = { ...alertSuccessModal };
        newItem.show = true;
        newItem.heading = "Alert";
        newItem.description =
          patientReports.length == 0
            ? t("string-literals.no-reports-added")
            : t("string-literals.empty-report");
        return newItem;
      });
      return;
    }


    if (reportDoneStatusState !== 2 && formatterAgentEnabled && !formattedReportUsed && !isExternal && conflictSave == "0") {
      console.log("Formatter Agent is enabled for radiologist ");
      setPendingSubmission(() => proceedWithSubmission);
      setShowFormatterPopup(true);
      return;
    }
    console.log("Formatter Agent is not enabled for radiologist");

    proceedWithSubmission(submissionData);
  };

  useEffect(() => {
    console.log("Checking Formatted agent popup status ", showFormatterPopup, pendingSubmission, pendingQCPass);
    if (!showFormatterPopup && pendingSubmission) {
      proceedWithSubmission();
      setPendingSubmission(null);
    }

    if (!showFormatterPopup && pendingQCPass) {
      proceedWithQCPass();
      setPendingQCPass(null);
    }
  }, [showFormatterPopup]);

  const proceedWithSubmission = async (submissionData) => {
    console.log("submission params", submissionParams, submissionData);
    if (!submissionParams && !submissionData) return;

    console.log("Proceeding with Submitting report...", patientReports);
    let data = !submissionParams ? submissionData : submissionParams;

    setLoaderRunning(true);
    setExternalReportingLoading(true);
    ref.current.continuousStart();
    try {
      let body = await getFormatedData(
        data.keyImages,
        data.annotationData,
        data.annotationDataAI,
        data.allTextToolAnnotation,
        data.activeViewportIndex,
        data.passConflictTemp,
        data.addendumDisclaimerAddedByRadVal,
        data.formattedReportAction ? data.formattedReportAction : formattedReportAction,
        data.updatedReports
      );
      // console.log("Getting body ", body);
      if (body?.loaded == true && body?.content == null) {
        setLoaderRunning(false);
        ref.current.complete();
        setExternalReportingLoading(false);
        setAlertSuccessModal(() => {
          const newItem = { ...alertSuccessModal };
          newItem.show = true;
          newItem.heading = "Alert";
          newItem.description =
            patientReports.length == 0
              ? t("string-literals.no-reports-added")
              : t("string-literals.empty-report");
          return newItem;
        });
        return;
      } else if (body.loaded == true && body.content != null) {
        let response = await submitReportTemplatesData(body.content);
        //let response = true;
        // console.log(response);
        // console.log(response.data.result);
        // console.log(
        //   response?.data?.message.includes(
        //     "Found conflict in patient sex and report content in"
        //   )
        // );
        if (
          (response.status === 200 && (response.data.result == "SUCCESS" || response.data.result == "WARNING")) ||
          (data.passConflictTemp != null &&
            data.passConflictTemp == true &&
            data.response.status === 200 &&
            (response.data.result == "SUCCESS" || response.data.result == "WARNING"))
        ) {
          let eventProperties = {};
          if (response.data.data.reportDoneStatus === 2) {
            logAmplitudeEventWithUsernameAndRole(
              "EVENT_BASIC_REPORT_SUBMIT",
              eventProperties,
              username
            );
          } else if (response.data.data.reportDoneStatus === 3) {
            logAmplitudeEventWithUsernameAndRole(
              "EVENT_BASIC_REPORT_SUBMIT_FOR_QC",
              eventProperties,
              username
            );
          }

          if (!isExternal) {
            getData(false, false);
          } else {
            setIsExternal(false);
            setIsClientReportExistExternalModal(null);
            setUpdateDoneSubmitDone(() => {
              const newItem = { ...updateRowSubmitDone };
              newItem.id = studyId;
              newItem.show = true;
              return newItem;
            });
            setOpenReportModal(false);
          }
          setLoaderRunning(false);
          ref.current.complete();
          setExternalReportingLoading(false);
          if (response.data.result == "WARNING") {
            showToastv2(
              TOAST_TYPE.INFO,
              response.data.message
            );
          }
          // showToastv2(TOAST_TYPE.SUCCESS, t("string-literals.submit-report"));

          // setShowToast((prev) => {
          //   return {
          //     ...prev,
          //     show: true,
          //     message: t("string-literals.submit-report"),
          //     loading: false,
          //     state: "success",
          //   };
          // });

          setShowSubmitTick(true);
          if (response.data.result == "WARNING") {
            setTimeout(() => {
              window.close();
              setShowSubmitTick(false);
            }, 3000);
          } else {
            setTimeout(() => {
              window.close();
              setShowSubmitTick(false);
            }, 2000);
          }

        } else if (response.data.result == "FAILURE") {
          if (
            response?.data?.message != null &&
            response?.data?.message?.includes(
              "Found conflict in patient sex and report content in"
            )
          ) {
            let conflictSaveTemp = response?.data?.message?.includes(
              "Found conflict in patient sex and report content in"
            )
              ? "1"
              : "0";
            setConflictSave("1");
            if (conflictSaveTemp == "1")
              setConfirmAlertModal(() => {
                const newItem = { ...confirmAlertModal };
                newItem.isConflictPopup = true;
                newItem.show = true;
                newItem.type = "submit";
                newItem.heading = "Alert";
                newItem.description = response.data.message;
                return newItem;
              });
          } else {
            switch (true) {
              case response?.data?.message != null &&
                response.data.message.includes(
                  t("string-literals.not-allowed-submit-report")
                ):
                setAlertSuccessModal(() => {
                  const newItem = { ...alertSuccessModal };
                  newItem.show = true;
                  newItem.heading = "Alert";
                  newItem.description = response.data.message;
                  return newItem;
                });
                break;
              case response.data.message ==
                t("string-literals.study-already-submitted-from-msword"):
                setAlertSuccessModal(() => {
                  const newItem = { ...alertSuccessModal };
                  newItem.show = true;
                  newItem.heading = "Alert";
                  newItem.description = response.data.message;
                  return newItem;
                });
                break;
              case response.data.message ==
                t("string-literals.message.can.not.submitted.study"):
                setAlertSuccessModal(() => {
                  const newItem = { ...alertSuccessModal };
                  newItem.show = true;
                  newItem.heading = "Alert";
                  newItem.description = response.data.message;
                  return newItem;
                });
                break;
              case response.data.message.includes(
                t(
                  "string-literals.cannot.submit.study.report.incomplete.findings.impression"
                )
              ):
                setAlertSuccessModal(() => {
                  const newItem = { ...alertSuccessModal };
                  newItem.show = true;
                  newItem.heading = "Alert";
                  newItem.description = response.data.message;
                  return newItem;
                });
                break;
              case response.data.message ==
                t(
                  "string-literals.can-not-save-or-submit-expired-study"
                ):
                setAlertSuccessModal(() => {
                  const newItem = { ...alertSuccessModal };
                  newItem.show = true;
                  newItem.heading = "Alert";
                  newItem.description = response.data.message;
                  return newItem;
                });
                break;
              case response.data.message ==
                t(
                  "string-literals.not-locked-study"
                ):
                setAlertSuccessModal(() => {
                  const newItem = { ...alertSuccessModal };
                  newItem.show = true;
                  newItem.heading = "Alert";
                  newItem.description = response.data.message;
                  return newItem;
                });
                break;
              case response.data.message ==
                t(
                  "string-literals.can-not-submit-closed-study"
                ):
                setAlertSuccessModal(() => {
                  const newItem = { ...alertSuccessModal };
                  newItem.show = true;
                  newItem.heading = "Alert";
                  newItem.description = response.data.message;
                  return newItem;
                });
                break;
              case response.data.message ==
                t(
                  "string-literals.can-not-submit-closed-study"
                ):
                setAlertSuccessModal(() => {
                  const newItem = { ...alertSuccessModal };
                  newItem.show = true;
                  newItem.heading = "Alert";
                  newItem.description = response.data.message;
                  return newItem;
                });
                break;
              case response.data.message ==
                t(
                  "string-literals.can-not-submit-already-submitted-study"
                ):
                setAlertSuccessModal(() => {
                  const newItem = { ...alertSuccessModal };
                  newItem.show = true;
                  newItem.heading = "Alert";
                  newItem.description = response.data.message;
                  return newItem;
                });
                break;
              case response.data.message ==
                t(
                  "string-literals.can-not-submit-peer-review-study"
                ):
                setAlertSuccessModal(() => {
                  const newItem = { ...alertSuccessModal };
                  newItem.show = true;
                  newItem.heading = "Alert";
                  newItem.description = response.data.message;
                  return newItem;
                });
                break;
              case response.data.message ==
                t(
                  "string-literals.can-not-submit-unassigned-study"
                ):
                setAlertSuccessModal(() => {
                  const newItem = { ...alertSuccessModal };
                  newItem.show = true;
                  newItem.heading = "Alert";
                  newItem.description = response.data.message;
                  return newItem;
                });
                break;
              case response.data.message ==
                t(
                  "string-literals.can-not-submit-as-submission-disabled"
                ):
                setAlertSuccessModal(() => {
                  const newItem = { ...alertSuccessModal };
                  newItem.show = true;
                  newItem.heading = "Alert";
                  newItem.description = response.data.message;
                  return newItem;
                });
                break;
              default:
                setAlertSuccessModal(() => {
                  const newItem = { ...alertSuccessModal };
                  newItem.show = true;
                  newItem.heading = "Error";
                  newItem.description = t("string-literals.error-msg");
                  return newItem;
                });
                break;
            }
          }
          //alert("Something goes wrong");
          //showToastv2(TOAST_TYPE.ERROR, t("string-literals.goesWrong"));
          setLoaderRunning(false);
          ref.current.complete();
          setExternalReportingLoading(false);
        }
      }
    } catch (e) {
      setLoaderRunning(false);
      ref.current.complete();
      setExternalReportingLoading(false);
      showToastv2(
        TOAST_TYPE.ERROR,
        t("string-literals.error-msg") + " Error Log: " + e.message
      );
    }
  };

  const reformateBoundingBox = async (
    annotationData,
    annotationDataAI,
    activeViewportIndex
  ) => {
    // console.log(annotationDataAI);
    const activeViewport = await getViewport(activeViewportIndex);
    // console.log("-------- Annotation Data --------");
    // console.log(annotationData);

    if (activeViewport != null || activeViewport != undefined) {
      let data = {};
      let allAnnotationUID = new Set();
      for (const key in annotationData) {
        if (!data[key]) {
          data[key] = {};
        }

        for (const key2 in annotationData[key]) {
          if (annotationData[key] != undefined) {
            // console.log(annotationData[key][key2]);
            annotationData[key][key2]?.map((ele, ind) => {
              allAnnotationUID.add(ele.annotation.annotationUID);
            });
            let temp = [];
            temp = annotationData[key][key2]?.map((ele, ind) => {
              const { imageData, dimensions } = activeViewport?.getImageData();

              let updatedPoints = [];
              updatedPoints.push(
                imageData.worldToIndex(ele.annotation.data.handles.points[0])
              );
              updatedPoints.push(
                imageData.worldToIndex(ele.annotation.data.handles.points[1])
              );
              updatedPoints.push(
                imageData.worldToIndex(ele.annotation.data.handles.points[2])
              );
              updatedPoints.push(
                imageData.worldToIndex(ele.annotation.data.handles.points[3])
              );

              let updatedJson = savingBoundingBoxJsonData(
                updatedPoints,
                ele.annotation.annotationUID
              );
              // console.log("---- Updated ----");
              // console.log(updatedJson);
              return JSON.stringify(updatedJson);
            });
            if (temp.length == 0) {
              continue;
            } else {
              data[key][key2] = temp;
            }
          }
        }
      }

      for (const key in annotationDataAI) {
        if (!data[key]) {
          data[key] = {};
        }

        for (const key2 in annotationDataAI[key]) {
          if (annotationDataAI[key] != undefined) {
            // console.log(annotationData[key][key2]);
            annotationDataAI[key][key2]?.map((ele, ind) => {
              allAnnotationUID.add(ele.annotation.annotationUID);
            });
            let temp = [];
            temp = annotationDataAI[key][key2]?.map((ele, ind) => {
              const { imageData, dimensions } = activeViewport?.getImageData();

              let updatedPoints = [];
              updatedPoints.push(
                imageData.worldToIndex(ele.annotation.data.handles.points[0])
              );
              updatedPoints.push(
                imageData.worldToIndex(ele.annotation.data.handles.points[1])
              );
              updatedPoints.push(
                imageData.worldToIndex(ele.annotation.data.handles.points[2])
              );
              updatedPoints.push(
                imageData.worldToIndex(ele.annotation.data.handles.points[3])
              );

              let updatedJson = savingBoundingBoxJsonData(
                updatedPoints,
                ele.annotation.annotationUID
              );
              // console.log("---- Updated ----");
              // console.log(updatedJson);
              return JSON.stringify(updatedJson);
            });
            if (temp.length == 0) {
              continue;
            } else {
              data[key][key2] = temp;
            }
          }
        }
      }
      data["AnnotationUIDs"] = allAnnotationUID;
      // console.log("--------- Final data ------------");
      // console.log(data);
      return { loadedComplete: true, measurementData: data };
    }
  };

  const getAnnotationData = (annotationId) => {
    for (let i = 0; i < reportAnnotationState.annotations_stuff.length; i++) {
      if (reportAnnotationState.annotations_stuff[i].id === annotationId) {
        return reportAnnotationState.annotations_stuff[i];
      }
    }
  };

  function getSelected_Ai_Annotations() {
    let selected_annotations = [];
    let annotation_stuff = reportAnnotationState.annotations_stuff;

    for (let i = 0; i < annotation_stuff.length; i++) {
      let annotationObj = annotation_stuff[i];
      let id = annotationObj.id;
      if (
        annotationObj.is_present === 1 &&
        annotationObj.ai_predicted === 1 &&
        (annotationObj.is_locked === true ||
          annotationObj.is_locked_check === true)
      ) {
        selected_annotations.push(id);
      }
    }

    return selected_annotations.sort();
  }

  const getSourceId = () => {
    switch (true) {
      case window?.location?.pathname?.includes(REPORT_SUBMIT_SOURCE.STUDYLIST):
        return 1;
      case window?.location?.pathname?.includes(
        REPORT_SUBMIT_SOURCE.ADVANCE_VIEWER
      ):
        return 3;
      case !window?.location?.pathname?.includes(
        REPORT_SUBMIT_SOURCE.ADVANCE_VIEWER
      ):
        return 2;
      default:
        return 2;
    }
  };

  function getNonSelected_Ai_Annotations() {
    let annotations = [];
    let annotation_stuff = reportAnnotationState.annotations_stuff;

    for (let i = 0; i < annotation_stuff.length; i++) {
      let annotationObj = annotation_stuff[i];
      let id = annotationObj.id;
      if (
        annotationObj.is_present === 1 &&
        annotationObj.ai_predicted === 1 &&
        (annotationObj.is_locked === false ||
          annotationObj.is_locked_check === false)
      ) {
        annotations.push(id);
      }
    }
    // iterate over deleted annotatiosn & send them as non selected annotaions
    // console.log(addStoreAnnotationState);
    for (
      let i = 0;
      i < addStoreAnnotationState?.annotations_stuff?.length;
      i++
    ) {
      let annotation_obj = addStoreAnnotationState?.annotations_stuff[i];
      let id = annotation_obj.id;
      if (
        annotation_obj.is_present === 1 &&
        annotation_obj.ai_predicted === 1 &&
        !annotations.includes(id)
      ) {
        annotations.push(id);
      }
    }
    // console.log(annotations);
    return annotations.sort();
  }

  const getFormattedReports = async (
    // annotationData,
    // annotationDataAI,
    // activeViewportIndex,
  ) => {
    // let data = await reformateBoundingBox(
    //   annotationData,
    //   annotationDataAI,
    //   activeViewportIndex
    // );

    // if (isExternal || isAdvanceViewer) {
    let opt = [];

    patientReports.map((ele, index) => {
      ele.reportDetails == undefined
        ? (ele.reportDetails = ele.report)
        : (ele.reportDetails = ele.reportDetails);
      if (ele.reportDetails != undefined && ele.reportDetails != null) {
        opt.push({
          reportTemplateId:
            ele.reportDetails.reportTemplateId == undefined
              ? ele.reportDetails.id
              : ele.reportDetails.reportTemplateId,
          reportTemplateTitle:
            ele.reportDetails.title == undefined
              ? ele.reportDetails.reportTemplateTitle
              : ele.reportDetails.title,
          finalReport:
            ele.reportDetails.report == undefined
              ? ele.reportDetails.finalReport
              : ele.reportDetails.report,
          isSuperSpecialReport:
            ele.reportDetails.isSuperSpecialReport == undefined
              ? 0
              : ele.reportDetails.isSuperSpecialReport,
          addendum:
            ele.reportDetails.addendum == undefined
              ? ""
              : ele.reportDetails.addendum,
        });
      }
    });

    let flag = true;
    opt.map((ele, index) => {
      const aux = document.createElement("div");
      aux.innerHTML = ele.finalReport;
      const regexPattern = /[^\x09][^\x0A][^\x0D][^\x20][^\x20-\uD7FF][^\uE000-\uFFFD\u{10000}-\u{10FFFF}][^\uD800-\uDBFF]/gu;

      if (ele?.finalReport != null && ele.finalReport != undefined) {
        var poweredByFroalaRegex =
          /<p[^>]*>\s*Powered by\s*<a[^>]*>Froala Editor<\/a>\s*<\/p>/gi;

        if (poweredByFroalaRegex.test(ele.finalReport)) {
          // console.log("--- Present Powered by text ----");
          var modifiedHtmlString = ele.finalReport.replace(
            poweredByFroalaRegex,
            ""
          );
          ele.finalReport = modifiedHtmlString;
        } else {
          // console.log("--- Not present powered by text ----");
        }
      }

      if (ele?.addendum != null && ele.addendum != undefined) {
        var poweredByFroalaRegex =
          /<p[^>]*>\s*Powered by\s*<a[^>]*>Froala Editor<\/a>\s*<\/p>/gi;

        if (poweredByFroalaRegex.test(ele.addendum)) {
          // console.log("--- Present Powered by text (addendum) ----");
          var modifiedHtmlString = ele.addendum.replace(
            poweredByFroalaRegex,
            ""
          );
          ele.addendum = modifiedHtmlString;
        } else {
          // console.log("--- Not present powered by text (addendum) ----");
        }
      }

      const trimmedContent = aux.innerText.trim();
      if (ele)
        if (
          trimmedContent == "" ||
          trimmedContent == "Powered by Froala Editor"
        ) {
          flag = false;
        }
    });

    if (!flag) {
      return null;
    }

    if (patientReports.length == 0) {
      return null;
    }
    return opt;
    // }
  }

  const getFormatedData = async (
    keyImages,
    annotationData,
    annotationDataAI,
    allTextToolAnnotation,
    activeViewportIndex,
    passConflictTemp,
    addendumDisclaimerAddedByRadVal,
    formattedReportAction,
    updatedReports
  ) => {
    let data = await reformateBoundingBox(
      annotationData,
      annotationDataAI,
      activeViewportIndex
    );
    // console.log("Data is ", data);
    // let isSpecialChar = false;
    if (
      (data != undefined && data?.loadedComplete == true) ||
      isExternal ||
      isAdvanceViewer
    ) {
      // console.log("------ Loaded -----");
      // console.log(data);
      let flag = checkReportContent(updatedReports);

      if (!flag) {
        return { loaded: true, content: null };
      }

      if (patientReports.length == 0 && (updatedReports === undefined || updatedReports?.length == 0)) {
        return { loaded: true, content: null };
      }

      // let annotations = JSON.stringify(getAllSelectedAnnotation());
      // if(matches != null && matches.length > 0 ){
      //   return null;
      // }
      let final_ai_annotations = {};
      let options_json = "";
      let extra_data = null;
      if (!isExternal && !isAdvanceViewer) {
        let locked_groups = {};
        let keys = Object.keys(reportAnnotationState.group_selections);
        keys.forEach((key) => {
          let annotation = getAnnotationData(parseInt(key));
          // console.log("Inside");
          // console.log(annotation);
          if (
            annotation.is_locked == true ||
            annotation.is_locked_check == true
          ) {
            locked_groups[key] = reportAnnotationState.group_selections[key];
          }
        });
        let groups_json = JSON.stringify(locked_groups);
        let locked_selections = {};
        keys = Object.keys(reportAnnotationState.selections);
        keys.forEach((key) => {
          let annotation = getAnnotationData(parseInt(key));
          if (
            annotation.is_locked == true ||
            annotation.is_locked_check == true
          ) {
            locked_selections[key] = reportAnnotationState.selections[key];
          }
        });

        let nonSelectedAiAnnotation = getNonSelected_Ai_Annotations();
        let selectedAiAnnotation = getSelected_Ai_Annotations();

        // console.log("selected ai annotations : ", selectedAiAnnotation);
        // console.log("non selected ai annotations : ", nonSelectedAiAnnotation);
        nonSelectedAiAnnotation.forEach((a) => {
          final_ai_annotations[a] = 0;
        });
        selectedAiAnnotation.forEach((a) => {
          final_ai_annotations[a] = 1;
        });
        // console.log("final_ai_annotations : ", final_ai_annotations);

        options_json = JSON.stringify(locked_selections);
        // console.log("Options json");
        // console.log(options_json);
        extra_data = JSON.stringify(reportAnnotationState.extra_value);
      } else {
      }
      //let smart_report_submitted_values = submittedValuesJson;
      // console.log("Is External ", isExternal);
      // console.log("---- AI Annotation JSon --- ", final_ai_annotations);
      // console.log("Pass Conflict ", passConflict);
      // console.log("Pass Conflict Temp ", passConflictTemp);
      // console.log("Save Conflict ", conflictSave);

      const findings = observationState?.findings?.map(f => {
        if (f.pathologyName.toLowerCase() == "other") {
          f.findingSentences[0].sentence = findingSentence;
          return f;
        } else {
          return f;
        }
      })

      const body = {
        studyReportSaveDto: {
          id: studyId,
          annotationJson:
            isExternal || isAdvanceViewer ? null : annotationsJson,
          aiAnnotationJson: JSON.stringify(
            isExternal || isAdvanceViewer ? "" : final_ai_annotations
          ),
          studyOptionsJson: options_json,
          extraValue: extra_data,
          conflictSave:
            passConflictTemp != null && passConflictTemp == true
              ? conflictSave == "0"
                ? "0"
                : "1"
              : "0",
          raiseAlert: raiseAlertValue,
          reportDoneStatus: 1,
          smartReportSubmittedValuesJson: null,
          studyReportList: getReportContent(updatedReports),
          imageAnnotationMeasurements: [],
          imageToolAnnotationMeasurements: [],
          studyKeyImages: isExternal || isAdvanceViewer ? [] : keyImages,
          assignmentIds: [],
          addendumDisclaimerAddedByRad: addendumDisclaimerAddedByRadVal,
          formattedReportAction: formattedReportAction,
          source: getSourceId(),
          studyObservationDto: selectedCategoryTemplate === "dsrTemplate" ? {
            clinicalHistory: observationState.clinicalHistory,
            technique: observationState.technique,
            impression: observationState.impressions,
            comparison: observationState.comparison,
            findings: findings == null || findings.length == 0 ? [{
              pathologyName: "other",
              findingSentences: [{ sentence: "No Findings", aiSentence: false, selected: true }]
            }] : findings
          } : null
        },
        isExternal: isExternal || isAdvanceViewer,
        annotationJson: isExternal || isAdvanceViewer ? null : annotationsJson,
        studyOptionsJson: options_json,
        allBoundingBox:
          isExternal || isAdvanceViewer ? [] : data.measurementData,
        allTextToolData:
          isExternal || isAdvanceViewer ? [] : allTextToolAnnotation,
      };

      // console.log("----- Body ------");
      // console.log(body);
      return { loaded: true, content: body };
    }
  };

  const checkReportContent = (updatedReports) => {
    let opt = getReportContent(updatedReports);
    let matches = [];
    let flag = true;
    opt.map((ele, index) => {
      const aux = document.createElement("div");
      aux.innerHTML = ele.finalReport;

      const regexPattern =
        /[^\x09][^\x0A][^\x0D][^\x20][^\x20-\uD7FF][^\uE000-\uFFFD\u{10000}-\u{10FFFF}][^\uD800-\uDBFF]/gu;


      if (ele?.finalReport != null && ele.finalReport != undefined) {
        var poweredByFroalaRegex =
          /<p[^>]*>\s*Powered by\s*<a[^>]*>Froala Editor<\/a>\s*<\/p>/gi;

        if (poweredByFroalaRegex.test(ele.finalReport)) {
          // console.log("--- Present Powered by text ----");
          var modifiedHtmlString = ele.finalReport.replace(
            poweredByFroalaRegex,
            ""
          );
          ele.finalReport = modifiedHtmlString;
        } else {
          // console.log("--- Not present powered by text ----");
        }
      }

      if (ele?.addendum != null && ele.addendum != undefined) {
        var poweredByFroalaRegex =
          /<p[^>]*>\s*Powered by\s*<a[^>]*>Froala Editor<\/a>\s*<\/p>/gi;

        if (poweredByFroalaRegex.test(ele.addendum)) {
          // console.log("--- Present Powered by text (addendum) ----");
          var modifiedHtmlString = ele.addendum.replace(
            poweredByFroalaRegex,
            ""
          );
          ele.addendum = modifiedHtmlString;
        } else {
          // console.log("--- Not present powered by text (addendum) ----");
        }
      }

      const trimmedContent = aux.innerText.trim();
      if (ele)
        if (
          trimmedContent == "" ||
          trimmedContent == "Powered by Froala Editor"
        ) {
          flag = false;
        }
    });

    return flag;
  }

  const getReportContent = (updatedReports) => {
    let opt = [];
    let reports = updatedReports ? updatedReports : patientReports;

    reports.map((ele, index) => {
      ele.reportDetails == undefined
        ? (ele.reportDetails = ele.report)
        : (ele.reportDetails = ele.reportDetails);
      if (ele.reportDetails != undefined && ele.reportDetails != null) {
        opt.push({
          reportTemplateId:
            ele.reportDetails.reportTemplateId == undefined
              ? ele.reportDetails.id
              : ele.reportDetails.reportTemplateId,
          reportTemplateTitle:
            ele.reportDetails.title == undefined
              ? ele.reportDetails.reportTemplateTitle
              : ele.reportDetails.title,
          finalReport:
            ele.reportDetails.report == undefined
              ? ele.reportDetails.finalReport
              : ele.reportDetails.report,
          isSuperSpecialReport:
            ele.reportDetails.isSuperSpecialReport == undefined
              ? 0
              : ele.reportDetails.isSuperSpecialReport,
          addendum:
            ele.reportDetails.addendum == undefined
              ? ""
              : ele.reportDetails.addendum,
        });
      }
    });

    return opt;
  }

  const regenerateClick = () => {
    let allAddedTabs = patientReports;
    let flag = false;
    allAddedTabs.map((ele, index) => {
      if (ele.text == RSNAModalContent.text) {
        flag = true;
        return;
      }
    });

    if (flag) {
      allAddedTabs = patientReports.filter((ele, index) => {
        if (ele.text != RSNAModalContent.text) {
          return ele;
        }
      });
    }
    setPatientReports(allAddedTabs);
    let generatedReport = generateRSNAReport();
    // console.log(generatedReport);

    // console.log("Falg" + flag);
    if (flag) {
      let rsnaContent = RSNAModalContent;
      if (rsnaContent.report.report != undefined) {
        rsnaContent.report.report = generatedReport;
      }
      allAddedTabs = patientReports.map((ele, index) => {
        if (ele.text === RSNAModalContent.text) {
          ele.reportDetails = rsnaContent.report;
        }
        return ele;
      });
    } else {
      let obj = {
        finalReport: generatedReport,
        reportTemplateId: RSNAModalContent.id,
        reportTemplateTitle: RSNAModalContent.text,
        isSuperSpecialReport: 0,
      };
      allAddedTabs.push({
        key: RSNAModalContent.key,
        text: RSNAModalContent.text,
        isSuperSpecialReport: 0,
        reportDetails: obj,
      });
    }
    // console.log(allAddedTabs);
    // console.log(dropdownSelectedTemplates);
    setPatientReports(allAddedTabs);

    let temp = allAddedTabs.filter((ele, ind) => {
      if (ele.text == RSNAModalContent.text) {
        return ele;
      }
    });
    // console.log(temp);
    handleChangeTemplate(temp[0]);

    // if(currentActiveTab == RSNAModalContent.text){
    //   console.log("Inside if");
    //handleModelChange(generatedReport,RSNAModalContent.text);
    // }
  };

  const regenerateHRCT = (props) => {
    let allAddedTabs = patientReports;

    let flag = false;

    allAddedTabs.map((ele, index) => {
      if (
        ele.reportDetails?.reportTemplateId == props.content.key ||
        ele.reportDetails?.id == props.content.key
      ) {
        flag = true;
        return;
      }
    });
    // console.log("flag is "+flag);
    if (flag) {
      allAddedTabs = patientReports.map((ele, ind) => {
        if (
          ele.reportDetails?.reportTemplateId == props.content.key ||
          ele.reportDetails?.id == props.content.key
        ) {
          ele.reportDetails = props.content.reportDetails;
          if (ele.reportDetails.reportTemplateId != undefined) {
            ele.reportDetails.reportTemplateId = props.content.key;
          } else {
            ele.reportDetails.id = props.content.key;
          }
        }
        return ele;
      });
    } else {
      let tempReport = props.content;
      tempReport.reportTemplateId = props.content.key;
      allAddedTabs.push({
        key: props.content.key,
        text: props.content.text,
        isSuperSpecialReport: 0,
        reportDetails: props.content.reportDetails,
      });
    }
    setPatientReports(allAddedTabs);
    setHasUnsavedChanges(true);
    let temp = allAddedTabs.filter((ele, ind) => {
      if (ele.text.includes(props.content.text)) {
        return ele;
      }
    });
    // console.log(temp);
    handleChangeTemplate(temp[0]);
  };

  const updatedHTMLString = (str) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = str;
    const elements = tempDiv.querySelectorAll("div");
    for (const element of elements) {
      if (
        element.textContent.includes("CORADS:") ||
        element.textContent.includes("CT SEVERITY SCORE:")
      ) {
        element.style.height = "";
      }
    }
    return tempDiv.innerHTML;
  };

  const generateRSNAReportAPICall = async (data, props) => {

    const layerElement = document.getElementById("fluent-default-layer-host");
    if (layerElement) {
      layerElement.style.display = 'block';
    }

    let s = "";
    if (data[2] != undefined) {
      data[2].value.map((ele, ind) => {
        s += ele + ",";
      });
    }
    // console.log(s);
    let body = {
      dto: {
        templateName: data[1].value,
        studyId: studyParentId,
        reportOrder: s,
        values: data[0].value,
      },
    };
    try {
      let res = await generateRSNADynamicReport(body);
      console.log("--- Response RSNA ---", res);
      if (res.data.result == "SUCCESS") {
        let result = res.data?.data?.data?.study_report_info;
        if (
          result.length > 0 &&
          props?.content?.text == REPORT_TITLE.HRCT_CHEST_COVID_SR
        ) {
          result[0].finalReport = updatedHTMLString(result[0].finalReport);
        }

        if (res.data.data?.data?.study_report_info.length > 0) {
          let allAddedTabs = patientReports;
          let flag = false;
          allAddedTabs.map((ele, index) => {
            if (ele.reportDetails?.reportTemplateId == props.content.key) {
              flag = true;
              return;
            }
          });
          // console.log("flag is "+flag);
          if (flag) {
            // console.log("Going true");

            allAddedTabs = patientReports.map((ele, ind) => {
              if (ele.reportDetails?.reportTemplateId == props.content.key) {
                ele.reportDetails = result[0];
                ele.reportDetails.reportTemplateId = props.content.key;
              }
              return ele;
            });
          } else {
            let tempReport = result[0];
            tempReport.reportTemplateId = props.content.key;
            allAddedTabs.push({
              key: props.content.key,
              text: result[0].reportTemplateTitle,
              isSuperSpecialReport: result[0].isSuperSpecialReport,
              reportDetails: tempReport,
            });
          }

          //console.log("All added tabs");
          //console.log(allAddedTabs);
          setPatientReports(allAddedTabs);
          setHasUnsavedChanges(true);
          let temp = allAddedTabs.filter((ele, ind) => {
            if (ele.text.includes(result[0].reportTemplateTitle)) {
              return ele;
            }
          });

          handleChangeTemplate(temp[0]);
          props.hideModal();
        }
      } else {
        setAlertSuccessModal(() => {
          const newItem = { ...alertSuccessModal };
          newItem.show = true;
          newItem.heading = "Error";
          newItem.description = res?.data?.message;
          return newItem;
        });
      }
    } catch (e) {
      console.log("----Exception----", e);
      setAlertSuccessModal(() => {
        const newItem = { ...alertSuccessModal };
        newItem.show = true;
        newItem.heading = "Error";
        newItem.description = t("string-literals.failed-message");
        return newItem;
      });
    }
  };

  const regenerateSmartReport = (result) => {
    result.map((tempVariableReport, ind) => {
      // console.log("Result is");
      // console.log(tempVariableReport);
      let allAddedTabs = patientReports;
      let flag = false;
      // 0 for checking it

      allAddedTabs.map((ele, index) => {
        if (ele.text.includes(tempVariableReport.reportTemplateTitle)) {
          flag = true;
          // return;
        }
      });
      let regeneratedReport = null;
      if (flag) {
        allAddedTabs = patientReports.map((ele, ind) => {
          if (ele.text.includes(tempVariableReport.reportTemplateTitle)) {
            if (
              tempVariableReport.finalReport != null &&
              tempVariableReport.finalReport != undefined
            ) {
              let updatedFontSizeReport = convertFontSize(
                tempVariableReport?.finalReport
              );
              tempVariableReport.finalReport = updatedFontSizeReport;
            }
            ele.reportDetails = tempVariableReport;
            ele.reportDetails.reportTemplateId =
              tempVariableReport.reportTemplateId;
            ele.text = tempVariableReport.reportTemplateTitle;
            regeneratedReport = ele;
          }
          return ele;
        });
      } else {
        // console.log("--- Regerating report ----");
        // console.log(tempVariableReport);
        if (
          tempVariableReport.finalReport != null &&
          tempVariableReport.finalReport != undefined
        ) {
          let updatedFontSizeReport = convertFontSize(
            tempVariableReport.finalReport
          );
          tempVariableReport.finalReport = updatedFontSizeReport;
        }

        allAddedTabs.push({
          key: tempVariableReport.reportTemplateId,
          text: tempVariableReport.reportTemplateTitle,
          isSuperSpecialReport: tempVariableReport.isSuperSpecialReport,
          reportDetails: tempVariableReport,
        });
        // console.log("-- allAddedTabs ", allAddedTabs);
        if (tempVariableReport.reportTemplateTitle.includes("Auto")) {
          regeneratedReport = {
            key: tempVariableReport.reportTemplateId,
            text: tempVariableReport.reportTemplateTitle,
            isSuperSpecialReport: tempVariableReport.isSuperSpecialReport,
            reportDetails: tempVariableReport,
          };
        }
      }
      let autoGeneneratedReport = allAddedTabs.filter((ele, ind) => {
        if (ele.text.includes("Auto Generated Report")) {
          return ele;
        }
      });
      if (regeneratedReport != null) {
        autoGeneneratedReport.push(regeneratedReport);
      }

      let autoGeneratedExist = false;
      let autoChestExist = false;
      allAddedTabs.map((ele, index) => {
        if (ele.text.includes("Auto Generated")) {
          autoGeneratedExist = true;
        }
      });

      allAddedTabs.map((ele, index) => {
        if (ele.text.includes("Auto Chest")) {
          autoChestExist = true;
        }
      });

      let updatedAllAddedTabs = [];
      if (autoChestExist && autoGeneratedExist) {
        updatedAllAddedTabs = allAddedTabs.filter(
          (ele) => !ele.text.includes("Auto Generated")
        );
      } else {
        updatedAllAddedTabs = allAddedTabs;
      }

      // console.log("--- Reaching here ---", updatedAllAddedTabs);
      setPatientReports(updatedAllAddedTabs);

      if (updatedAllAddedTabs.length > 0) {
        let lastlyAddedReport =
          updatedAllAddedTabs[updatedAllAddedTabs.length - 1];
        handleChangeTemplate(lastlyAddedReport);
      }

      // let temp1 = allAddedTabs.filter((ele, ind) => {
      //   if (tempVariableReport.reportTemplateTitle.includes("Auto")) {
      //     return ele;
      //   }
      // });
      // let temp2 = allAddedTabs.filter((ele, ind) => {
      //   if (
      //     tempVariableReport.reportTemplateTitle.includes("General") &&
      //     ele.text.includes("General")
      //   ) {
      //     return ele;
      //   }
      // });
      // if (temp1.length > 0) {
      //   // console.log(temp1);
      //   handleChangeTemplate(temp1[0]);
      // }
      // if (temp2.length > 0) {
      //   handleChangeTemplate(temp2[0]);
      // }
    });
  };

  const generateMRISpineReport = async (data, props) => {
    let body = {
      dto: {
        templateName: data[1].value,
        studyId: studyParentId,
        reportOrder: null,
        values: data[0]?.value,
      },
    };
    // console.log(body);
    try {
      setLoaderRunning(true);
      ref.current.continuousStart();
      let res = await generateMRISpineReportCall(body);
      if (res.data.result == "SUCCESS") {
        // console.log(patientReports);
        setLoaderRunning(false);
        ref.current.complete();
        let result = res.data?.data?.data?.study_report_info;

        if (res.data.data?.data?.study_report_info.length > 0) {
          let allAddedTabs = patientReports;
          let flag = false;
          allAddedTabs.map((ele, index) => {
            if (ele.reportDetails?.reportTemplateId == props.content.key) {
              flag = true;
              return;
            }
          });
          // console.log("flag is "+flag);
          if (flag) {
            // console.log("Going true");

            allAddedTabs = patientReports.map((ele, ind) => {
              if (ele.reportDetails?.reportTemplateId == props.content.key) {
                ele.reportDetails = result[0];
                ele.reportDetails.reportTemplateId = props.content.key;
              }
              return ele;
            });
          } else {
            let tempReport = result[0];
            tempReport.reportTemplateId = props.content.key;
            allAddedTabs.push({
              key: props.content.key,
              text: result[0].reportTemplateTitle,
              isSuperSpecialReport: result[0].isSuperSpecialReport,
              reportDetails: tempReport,
            });
          }

          //  console.log("All added tabs");
          //   console.log(allAddedTabs);
          setPatientReports(allAddedTabs);
          setHasUnsavedChanges(true);
          let temp = allAddedTabs.filter((ele, ind) => {
            if (ele.text.includes(result[0].reportTemplateTitle)) {
              return ele;
            }
          });

          handleChangeTemplate(temp[0]);
          props.hideModal();
        }
      }
    } catch (e) {
      setLoaderRunning(false);
      ref.current.complete();
      showToastv2(
        TOAST_TYPE.ERROR,
        t("string-literals.error-msg") + " Error Log: " + e.message
      );
    }

    setReportModalState(() => {
      const newVal = { ...reportModalState };
      newVal.mriSpine = false;
      newVal.content = {};
      return newVal;
    });
  };

  const generateCTBrainReport = async (data, props) => {
    // console.log(data);
    let body = {
      dto: {
        templateName: null,
        studyId: studyParentId,
        reportOrder: null,
        values: data[0]?.value,
      },
    };
    let res = await generateCTBrainReportCall(body);
    // console.log(res);
    if (res.data.result == "SUCCESS") {
      let result = res.data?.data?.data?.study_report_info;

      if (res.data.data?.data?.study_report_info.length > 0) {
        let allAddedTabs = patientReports;
        let flag = false;
        allAddedTabs.map((ele, index) => {
          if (ele.reportDetails?.reportTemplateId == props.content.key) {
            flag = true;
            return;
          }
        });
        // console.log("Flag is "+flag);
        if (flag) {
          allAddedTabs = patientReports.map((ele, ind) => {
            if (ele.reportDetails?.reportTemplateId == props.content.key) {
              ele.reportDetails = result[0];
              ele.reportDetails.reportTemplateId = props.content.key;
            }
            return ele;
          });
        } else {
          let tempReport = result[0];
          tempReport.reportTemplateId = props.content.key;
          allAddedTabs.push({
            key: props.content.key,
            text: "CT BRAIN SR",
            isSuperSpecialReport: result[0].isSuperSpecialReport,
            reportDetails: tempReport,
          });
        }
        setPatientReports(allAddedTabs);
        let temp = allAddedTabs.filter((ele, ind) => {
          if (ele.reportDetails?.reportTemplateId == props.content.key) {
            return ele;
          }
        });
        setHasUnsavedChanges(true);
        handleChangeTemplate(temp[0]);
        props.hideModal();
      }
    } else {
      //alert("Error while in creating smart report");
    }
  };

  const hideCommnunicationModal = () => {
    setShowCommunicationModal(false);
  };

  const handleMarkAsSuspect = async () => {
    setLoaderRunning(true);
    try {
      ref.current.continuousStart();
      let response = await markAsSuspect(studyId, firmId);
      if (response.status === 200 && response.data.result == "SUCCESS") {
        setLoaderRunning(false);
        ref.current.complete();
        showToastv2(TOAST_TYPE.SUSPECT, t("mark-as-suspect.success"));
        setShowSuspectIcon(true);
        setTimeout(() => {
          setShowSuspectIcon(false);
          window.close();
        }, 1000);
      } else if (response.data.result == "FAILURE") {
        setLoaderRunning(false);
        ref.current.complete();
        showToastv2(TOAST_TYPE.ERROR, response.data.message);
      } else {
        setLoaderRunning(false);
        ref.current.complete();
        showToastv2(TOAST_TYPE.ERROR, t("mark-as-suspect.error"));
      }
    } catch (e) {
      showToastv2(
        TOAST_TYPE.ERROR,
        t("string-literals.error-msg") + " Error Log: " + e.message + e.message
      );
    }
  };

  const handleDownloadDoc = async (studyId) => {
    try {
      let response = await getWordSession(
        studyId
      );
      if (response.status == 200) {
        if (response.data.result == "SUCCESS") {
          if (isExternal) {
            setIsExternal(false);
            setOpenReportModal(false);
            setIsClientReportExistExternalModal(null);
          }
          var wordDocUrl = DICOM_ACCEPTOR_BASE_URL + APIs.OPENWORD + studyId + ".docx" + '?session_id=' + response.data.data + '&user_id=' + userId + '&study_id=' + studyId;

          var wordInstance = document.createElement("a");
          wordInstance.id = "lnkMsWord";
          var link = document.createTextNode("word link");
          wordInstance.appendChild(link);
          wordInstance.title = "ms-word";
          wordInstance.href = "ms-word:ofe|u|" + wordDocUrl;
          wordInstance.click();
        } else {
          showToastv2(TOAST_TYPE.ERROR, response.data.message);
        }
      } else {
        showToastv2(TOAST_TYPE.ERROR, t("string-literals.word-exception"));
      }
    } catch (e) {
      showToastv2(
        TOAST_TYPE.ERROR,
        t("string-literals.error-msg") + " Error Log: " + e.message + e.message
      );
    }

  }








  function hasTextChanged(html1, html2) {
    const extractCleanText = (html) => {
      const div = document.createElement('div');
      div.innerHTML = html || '';

      let text = div.textContent || '';

      // Normalize:
      return text
        .replace(/\u00A0/g, ' ')        // convert non-breaking spaces to normal
        .replace(/\s+/g, '')           // collapse multiple whitespace
        .replace(/^\s+|\s+$/g, '')      // trim leading/trailing
        .trim();
    };

    const text1 = extractCleanText(html1);
    const text2 = extractCleanText(html2);

    return text1 !== text2;
  }

  function getBodyPart(title) {
    if (!title) return "";

      const lowerTitle = title.toLowerCase();
      if (lowerTitle.includes("ct brain")) {
        return "brain";
      } else if (lowerTitle.includes("mri lumbar spine")) {
        return "lumbar";
      } else if (lowerTitle.includes("msk")) {
        return "msk";
      } else {
        return "chest";
      }
  }


  function getModalityForLLM(modality) {
    switch (modality) {
      case "MR":
        return "mri";
      case "CT":
        return "ct";
      default:
        return "xray";
    }
  }

  const getTechniqueByTitle = (title) => {
    if (!title) return "";

    const lowerTitle = title.toLowerCase();
    if (lowerTitle.includes("ct brain")) {
      return "Non-contrast axial images were acquired through the brain.";
    } else if (lowerTitle.includes("mri lumbar spine")) {
      return "Multiplanar and multiecho MRI of the lumbar spine was performed.";
    } else {
      return "Frontal projections of the chest were obtained.";
    }
  };




  const handleDSRRegenerate = async () => {
    const changed = resetLLMReportClicked ? true : hasTextChanged(reportFromAPI, editorRef.current.editor.html.get());
    let newLLMId = "";
    if (resetLLMReportClicked) {
      newLLMId = generateRandomString(userId, studyId);
      setLlmSessionId(newLLMId);
    }

    const observationText = inputValue.trim();
    let images = [];
    if (isExternal) {
      images = [];
    } else {
      const imagePromises = Object.values(maskImages)
        .filter(item => item)
        .map(item => loadDicomAndDrawRectangle(item.imageURL, item.maskAnnotationData));

      images = await Promise.all(imagePromises);
    }

    const llmReportDto = {
      sessionId: resetLLMReportClicked ? newLLMId : llmSessionId,
      studyId: studyId,
      radiologistId: userId,
      firmId: firmId,
      modality: getModalityForLLM(modality),
      organ: getBodyPart(reportTitle),
      images: images ? images : [],
      observations: observationText,
      clinicalHistory: observationState.clinicalHistory,
      clinicalNotes: studyClinicalNotesData,
      technique: getTechniqueByTitle(reportTitle),
      comparison: observationState.comparison,
      // reportTitle: currentActiveTab,
      reportTitle: reportTitle,
      personalizationLevel: "radiologist",
      rag: "Yes",
      globalRAG: "No",
      textReport: changed ? editorRef.current.editor.html.get() : "",

    }

    setLoaderRunning(true);
    ref.current.continuousStart();
    const response = await regenerateLLMReport(llmReportDto);
    setLoaderRunning(false);
    ref.current.complete();
    if (response.status === 200) {
      setReportFromAPI(response.data.data.finalReport);
      handleModelChange(response.data.data.finalReport, false);
      setActiveTab(1);
      setDisableCopyButton(false);
      setDisableResetReport(false);
      if (firstAgenticLLMReport === "") {

        setFirstAgenticLLMReport(response.data.data.finalReport);
      }
      const newObject = { prompt: inputValue.trim(), isNote: false }
      setUserPrompts(prevPrompts => [newObject, ...prevPrompts]);
      setInputValue('');
      setResetLLMReportClicked(false);
      if (!isExternal){
        removeMaskImageAnnotation(maskImages);
        setMaskImages([]);
        disableMasking();
      }

    } else {
      setAlertSuccessModal(() => {
        const newItem = { ...alertSuccessModal };
        newItem.show = true;
        newItem.heading = "Error";
        newItem.description = response.data.message;
        return newItem;
      });
    }

  }

  return (
    <StudyReportContext.Provider
      value={{
        model,
        setModel,
        studyId,
        modality,
        patientReports,
        setPatientReports,
        //showToast,
        //setShowToast,
        selectedCategoryTemplate,
        setSelectedCategoryTemplate,
        dropdownSelectedTemplatesStore,
        setDropdownSelectedTemplatesStore,
        allReportTemplates,
        setAllReportTemplates,
        dropdownSelectedTemplates,
        setDropdownSelectedTemplates,
        reset,
        setReset,
        userActionLoading,
        setUserActionLoading,
        hideDialog,
        setToggleHideDialog,
        isDraggable,
        showAlert,
        setShowAlert,

        annotationsJson,
        setAnnotationsJson,
        studyOptionJson,
        setStudyOptionJson,

        disableDownload,
        disablePreview,
        disableSave,
        setDisableSave,
        disableSubmit,
        setDisableSubmit,
        disableRaiseAlert,

        suggestedListReport,
        firstReportAdded,
        setFirstReportAdded,
        setSuggestedListReport,
        lockStudy,

        handleDropdown,
        handleModelChange,
        handleRemoveTemplate,
        handleChangeTemplate,
        handleActiveTab,
        refreshReport,
        downloadReport,
        handlePreviewReport,
        handlePreviewReportVersion,
        handleSaveReport,
        handleSubmitReport,
        handleRaiseAlertDropdown,
        handleAnnotationJsonData,
        handleDropdownWithContext,
        currentActiveTab,
        setCurrentActiveTab,
        setOpenRSNAModal,
        setRSNAModalContent,
        regenerateClick,
        generateRSNAReportAPICall,
        setEnableReportRegenerate,
        setReportMenu,
        setSeriesMenu,
        setReportModalState,
        regenerateHRCT,

        generateCTBrainReport,
        generateMRISpineReport,

        reportMenu,
        seriesMenu,
        showLockButton,
        reportSavedSuccess,

        enableReportRegenerate,
        RSNAModalContent,
        openRSNAModal,
        reportModalState,

        raiseAlertList,
        raiseAlertValue,
        setRaiseAlertValue,
        showLockWarning,
        disablePenEye,
        setDisablePenEye,
        disableQCPass,
        disableQCReturn,
        handleQcPass,
        handleQcReturn,
        setOpenQcModal,
        openQcModal,
        qcProviderList,
        handleQcReturnButtonClick,
        openQcReasonModal,
        setOpenQcReasonModal,
        disableQCReason,
        setDisableQcReason,
        handleQCReasonClick,
        disableSubmitUntilQCReasonClick,
        qcFailReason,
        reportAnnotationState,
        setReportAnnotationState,
        regenerateSmartReport,
        userRole,
        alreadyLocked,
        showReturnedStudyReasonModal,
        setShowReturnedStudyReasonModal,
        checkIfCancelOrNot,
        activeTab,
        setActiveTab,
        disableAddendumTab,
        addendumModel,
        setAddendumModel,
        showReturnStudyModal,
        setShowReturnStudyModal,
        unlockStudy,
        releaseStudy,
        reportDoneStatusState,
        showCommunicationModal,
        setShowCommunicationModal,
        hideCommnunicationModal,

        alertSuccessModal,
        setAlertSuccessModal,
        confirmAlertModal,
        setConfirmAlertModal,
        hideAlertSuccessModal,
        handleUpdateStudyId,
        setStudyParentId,
        openReportModal,
        setOpenReportModal,
        modalityReport,
        setModalityReport,
        isClientReportExist,
        setIsClientReportExist,
        downloadFistolugram,
        openFistolugramUploadModal,
        setFistolugramUploadModal,
        showFistolugram,
        uploadFistolugramFunc,
        fistolugramFilePath,
        showQCReasonBadge,
        setShowQCReasonBadge,
        conflictSave,
        setConflictSave,
        passConflict,
        setPassConflict,
        getData,
        showKeyImagesAndTextAnnotation,
        openQCPassConfirmModal,
        setOpenQCPassConfirmModal,
        isKeyImagesPresent,
        isTextAnnotationPresent,
        setIsKeyImagesPresent,
        setIsTextAnnotationPresent,
        hasUnsavedChanges,
        setHasUnsavedChanges,
        firmId,
        setFirmId,
        showAddendumDisclaimerPopup,
        setShowAddendumDisclaimerPopup,
        addendumDisclaimerAddedByRad,
        setAddendumDisclaimerAddedByRad,
        showAddendumDisclaimerModal,
        setShowAddendumDisclaimerModal,
        showConfirmModal,
        setShowConfirmModal,
        isExternal,
        setIsExternal,
        showSubmitTick,
        setShowSubmitTick,
        studyParentId,
        setAllStoreAnnotation,
        addStoreAnnotationState,
        setAddStoreAnnotationState,
        allowDownloadReport,
        studyPatientDetails,
        setStudyPatientDetails,
        externalReportingModalRef,
        externalReportingLoading,
        setExternalReportingLoading,
        handleMarkAsSuspect,
        disableMarkAsSuspect,
        showSuspectIcon,
        setShowSuspectIcon,
        hideLockWarningMessage,
        updateRowSubmitDone,
        setUpdateDoneSubmitDone,
        setIsClientReportExistExternalModal,
        isAdvanceViewer,
        setIsAdvanceViewer,
        getConsistentDateFormat,
        setShowKeyImagesAndTextAnnotation,
        isChildStudyReportState,
        setIsChildStudyReportState,
        handleUpdateReportSection,
        keyImagePresentStudyList,
        setKeyImagePresentStudyList,
        showMsWord,
        setShowMsWord,
        setIsWordFilePath,
        isWordFilePath,
        childModel,
        childPatientReports,
        childCurrentActiveTab,
        handleChildChangeTemplate,
        lockStudySupervisor,
        getConsistentCustomDateFormat,
        downloadAIReport,
        allowCopyPaste,
        lockedByOther,
        allReportTemplatesLoading, setAllReportTemplateLoading,
        setIsRestrictionsEnabled, isRestrictionsEnabled,
        handleDownloadDoc,
        forceReinferenceInProgress, setForReinferenceInProgress,
        showForceReinferenceModal, setShowForceReinferenceModal,
        isDSRExists,
        observationState, setObservationState,
        handleDSRRegenerate,
        studyDescription, setStudyDescription,
        findingSentence, setFindingSentence,
        disableObservations,
        showFindingsErrorMessage, setShowFindingsErrorMessage,
        showTemplateList, setShowTemplateList,
        rsnaFlag, setRSNAFlag, handleSwitchCategory,
        fetchS10Report,
        s10User,
        s10Url,
        confirmMultipleTemplateOpen, confirmMultipleTemplateModalContent,
        editorRef,
        inputValue, setInputValue,
        activeField,
        setActiveField,
        formatterAgentEnabled, formattedReportUsed,
        showFormatterPopup, setShowFormatterPopup, showFormatterPopupClipped, setShowFormatterPopupClipped, clippedKeyImagesData, setClippedKeyImagesData, previewClippedKeyImageBase64, setPreviewClippedKeyImageBase64, setPendingSubmission, setFormattedReportAction, setPendingQCPass,
        templateHeight, setTemplateHeight, usgAgentEnabled, maskedImageEnabledLimit, reportingDoctorName, firstAgenticLLMReport,
        userPrompts, setUserPrompts,
        disableResetReport, setDisableResetReport,
        disableCopyButton, setDisableCopyButton,
        chatInputRef,
        registerChatInputRef,
        setReportFromAPI,
        reportTitle, setReportTitle,
        llmReportTitle, setLlmSessionId,
        setResetLLMReportClicked,
        maskImages,
        agenticReportAgents,
        setAgenticReportAgents,
        allReportTemplatesLoading, setAllReportTemplateLoading,
      }}
    >
      {props.children}
    </StudyReportContext.Provider>
  );
};

export default StudyReportState;
